import * as React from "react";
import type { SVGProps } from "react";
const SvgAndorra = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1280 720" {...props}>
    <defs>
      <style>
        {
          ".Andorra_svg__cls-3,.Andorra_svg__cls-34,.Andorra_svg__cls-7{fill:#fcde00}.Andorra_svg__cls-14,.Andorra_svg__cls-15,.Andorra_svg__cls-18,.Andorra_svg__cls-21,.Andorra_svg__cls-24,.Andorra_svg__cls-26,.Andorra_svg__cls-31,.Andorra_svg__cls-33,.Andorra_svg__cls-5,.Andorra_svg__cls-8,.Andorra_svg__cls-9{fill:none}.Andorra_svg__cls-15,.Andorra_svg__cls-26,.Andorra_svg__cls-31,.Andorra_svg__cls-5,.Andorra_svg__cls-8{stroke-linecap:round}.Andorra_svg__cls-17,.Andorra_svg__cls-18,.Andorra_svg__cls-24,.Andorra_svg__cls-31,.Andorra_svg__cls-33,.Andorra_svg__cls-5,.Andorra_svg__cls-8,.Andorra_svg__cls-9{stroke-miterlimit:3.86}.Andorra_svg__cls-31,.Andorra_svg__cls-33,.Andorra_svg__cls-5,.Andorra_svg__cls-8,.Andorra_svg__cls-9{stroke-width:.99px}.Andorra_svg__cls-17,.Andorra_svg__cls-5{stroke:#c6b37f}.Andorra_svg__cls-17,.Andorra_svg__cls-6{fill:#c6b37f}.Andorra_svg__cls-14,.Andorra_svg__cls-15,.Andorra_svg__cls-18,.Andorra_svg__cls-21,.Andorra_svg__cls-24,.Andorra_svg__cls-26,.Andorra_svg__cls-7,.Andorra_svg__cls-8,.Andorra_svg__cls-9{stroke:#713e2a}.Andorra_svg__cls-14,.Andorra_svg__cls-15,.Andorra_svg__cls-21,.Andorra_svg__cls-26,.Andorra_svg__cls-32,.Andorra_svg__cls-34,.Andorra_svg__cls-35,.Andorra_svg__cls-7{stroke-miterlimit:3.86}.Andorra_svg__cls-7{stroke-width:.8px}.Andorra_svg__cls-15{stroke-width:1.04px}.Andorra_svg__cls-14,.Andorra_svg__cls-26{stroke-width:1.12px}.Andorra_svg__cls-16,.Andorra_svg__cls-35{fill:#d32d27}.Andorra_svg__cls-17,.Andorra_svg__cls-32,.Andorra_svg__cls-34,.Andorra_svg__cls-35{stroke-width:.51px}.Andorra_svg__cls-18{stroke-width:1.06px}.Andorra_svg__cls-21{stroke-width:1.36px}.Andorra_svg__cls-23{fill:#713e2a}.Andorra_svg__cls-24{stroke-width:.88px}.Andorra_svg__cls-29{fill:#fff}.Andorra_svg__cls-30{fill:#1f66b0}.Andorra_svg__cls-31,.Andorra_svg__cls-32,.Andorra_svg__cls-33{stroke:#fcde00}.Andorra_svg__cls-32{fill:#fad701}.Andorra_svg__cls-34{stroke:#fad701}.Andorra_svg__cls-35{stroke:#d32d27}"
        }
      </style>
    </defs>
    <g id="Andorra_svg__Andorra">
      <path
        id="Andorra_svg__rect3"
        d="M0 0v720h409.6V0Z"
        style={{
          fill: "#283893",
        }}
      />
      <path
        id="Andorra_svg__rect5"
        d="M870.4 0v720H1280V0Z"
        style={{
          fill: "#cf1f3c",
        }}
      />
      <path
        id="Andorra_svg__rect7"
        d="M409.6 0h460.8v720H409.6z"
        className="Andorra_svg__cls-3"
      />
      <path
        id="Andorra_svg__path2522"
        d="m663.35 207.06-2.56-1.42c-2.13-1.17-4.41-.93-5.51.4-1.24 1.5-1.68 4.07 0 5.66"
        style={{
          fill: "none",
          stroke: "#221f1f",
          strokeLinecap: "round",
          strokeMiterlimit: 3.86,
          strokeWidth: ".99px",
        }}
      />
      <path
        id="Andorra_svg__path2524"
        d="M509.92 401.08a27 27 0 0 1-1.29 2.51c-.55 1-.84 1.61-1.43 2.61s-.91 1.52-1.54 2.46c-.84 1.28-1.4 1.93-2.31 3.17"
        className="Andorra_svg__cls-5"
      />
      <path
        id="Andorra_svg__path2526"
        d="M600.77 153.64c15.57 0 21.94 13.36 37.51 13.36 9.61 0 15.22-3.14 23.59-7.87 5.85-3.31 9.58-5.07 16.29-5.07 6.87 0 11.09 2.08 14.6 8 2 3.33 3.64 9.85 2.76 13.6a80.4 80.4 0 0 1-5.5 16.73c-1.35 3.15-2.62 5-2.62 8.49 0 8.26 11.24 11.1 18.89 11.22 1.67 0 15.68.25 24.31-8.48-4.68-.21-9.92-3.83-9.92-8.51 0-5.3 3.72-8.88 8.77-10.41 1-.27 2.59.57 3.46.11 1.23-.63.66-2 1.75-2.89 2.51-2 4.15-3.26 7.37-3.26a7.42 7.42 0 0 1 5 1.5c.88.64 1.21 1.43 2.31 1.43 2.31 0 3.45-1.46 5.75-1.46a8.83 8.83 0 0 1 4.66 1.1c1.37.71 1.34 3 2.89 3 .78 0 4.88-1.67 7-1.67 4.45 0 6.83 1.61 9.71 5 .77.91 1.27 2.76 2.06 2.76a12.57 12.57 0 0 1 7.53 3.31 12.2 12.2 0 0 1 2.17 2.63c.53.85 1.33 2.91 2.26 3.27 1.09.41 2 .33 3.43 1.25 3.27 2.09 5.78 6 5.66 9.83a20.4 20.4 0 0 1-1 4.28c-3.8 13.29-12.84 17.51-22 28.92-3.88 4.86-6.94 8.74-6.94 15 0 1.5 1.85 4.26 2.67 5.52-.5-2.93.84-6.53 3.94-6.69 4.24-.23 7.51 3 8.09 7.19a9.3 9.3 0 0 1-.67 3.68 19.34 19.34 0 0 1 8-2.84 24.7 24.7 0 0 1 3.85-.17c6.77.17 14.25 4 18.79 7.84 13.89 11.79 15.57 29.06 14.81 33.85-1.68 10.66-.62 29.94-27.86 37.62 5 2.12 8.47 5.91 8.47 10.57a9.19 9.19 0 0 1-9 9.41 8.82 8.82 0 0 1-6.94-2.74c-5.67 5.66-6.76 11.43-6.76 19.45 0 4.79.91 7.62 2.92 12 2.12 4.59 3.65 7.28 7.49 10.6 2-3.06 4.18-5.3 7.85-5.3s6.58 1.14 8 4.38c.43 1 .05 1.78.55 2.74.64 1.23 1.71 1.51 2.37 2.74 1 1.9 0 3.52.92 5.48.57 1.28 1.82 1.46 2.37 2.74a11.8 11.8 0 0 1 1.1 5.48c0 6.07-5.53 10.41-11.6 10.41-1.83 0-2.83-.73-4.66-.55 3.47 3.47 6.12 5 8.77 9.14 3.83 6 4.79 10.27 5.66 17.35a25 25 0 0 1 .18 3.47c0 9.08-1.41 14.52-5.48 22.64-3.88 7.79-7.19 12.1-14.24 17.17-11 7.92-19 10.21-32.33 12.79a151 151 0 0 1-22.1 2.92c-11.1.71-17.42.73-28.49 1.46-14.53 1-24.59 3-34.89 13.33 4.86 3.57 8.22 7.06 8.22 13.06 0 6.17-3.81 10.57-9.68 12.51-1.37.46-2.38 0-3.65.73-1.53.8-1.47 2.56-2.93 3.47a12.5 12.5 0 0 1-7.67 2c-5.43 0-9.13-1.29-13-5.12-4.45 3.7-6 7-11 9.86-1.65.92-2.49 2.19-4.39 2.19-3 0-4.36-1.89-6.76-3.65a46.2 46.2 0 0 1-9-8.22c-4.54 2.72-7.32 4.94-12.6 4.94a13.1 13.1 0 0 1-8-2.2c-1.44-.89-1.67-2.21-3.11-3.1s-2.76-.6-4.38-1.28c-6.1-2.63-10-7.15-10-13.79 0-5.82 3.68-9.52 9-12-10.11-10.11-20.07-11.87-34.34-12.78-11-.71-17.3-.73-28.31-1.46a198 198 0 0 1-22.28-2.92c-6.55-1.08-10.43-1.42-16.44-4.2-20.66-9.64-33.83-22.86-36.53-45.48a36.5 36.5 0 0 1-.18-5c0-11.78 4.63-19 13-27.31-2.15-.5-3.59.21-5.66-.55-5.21-1.89-8.95-5.5-8.95-11a9.3 9.3 0 0 1 1.09-5.2c.71-1.26 2.06-1.51 2.38-2.93.41-1.87-.14-3.19.73-4.93.57-1.16 1.64-1.39 2.19-2.55 1.8-3.75 4.06-6.76 8.22-6.76 3.56 0 5.84 1.87 7.67 4.93 3.47-1.6 4.43-4.2 6.39-7.49 3.27-5.46 4.75-9.27 4.75-15.62a30.7 30.7 0 0 0-1.83-11.23c-1-3-1.41-5.07-3.65-7.3a8.82 8.82 0 0 1-6.94 2.74c-5.8 0-10.23-5-10.23-10.78a9.7 9.7 0 0 1 6-9.31c-3.13-2.7-5.84-2.93-9.31-5.12-5.28-3.33-7.13-6.85-10.6-12.05-2.26-3.41-2.85-5.78-4-9.68-1.39-4.71-2.19-7.51-2.19-12.42a22.5 22.5 0 0 1 .18-3.29c1.49-10 3.29-16.2 9.49-24.02 3.7-4.63 6.21-7.49 11.69-9.86 4.66-2 7.44-3.47 12.51-3.47a29 29 0 0 1 3.93.18 13.9 13.9 0 0 1 5.84 1.65c.78.43 2.19 1.73 2.19.82s-.54-1.6-.54-2.65c0-4.2 3-8 7.21-8 3 0 4.27 2.67 5.75 5.3a7.86 7.86 0 0 0 1.46-4.57c0-6.94-3.72-10.47-8-15.89-9.41-11.75-21.19-17.26-21.19-32.32 0-4.5 2.17-7.56 6-9.87 1.12-.66 2.62 0 3.72-.7.93-.59.82-1.8 1.42-2.76a13.4 13.4 0 0 1 3.06-3.26c2.15-1.87 4-1.31 6.41-3 1.19-.82 1.47-1.89 2.38-3 2.65-3.2 5-4.74 9.2-4.74a12 12 0 0 1 5.22.78c.67.25 1.9 1.25 2.06 1.06a9.7 9.7 0 0 1 2.9-2.34 8.2 8.2 0 0 1 4.44-1.18c2.23 0 3.7 1.26 5.94 1.26.82 0 1-.82 1.67-1.26 2-1.34 3.13-2.1 5.55-2.1s3.62.77 5.58 2 2.11 2.72 4 3.82c1 .62 1.94.34 3.1.73 5.21 1.74 9.14 5.21 9.14 10.69 0 3-.71 5.09-2.93 7-1.75 1.55-3.42 1.28-5.66 2 7.26 5.8 13.58 7.23 22.85 7.23 8.49 0 18.88-3.47 18.88-12 0-3.95-2.18-6.07-3.74-9.7-2.78-6.46-4.29-10.26-4.29-17.3 0-5.57.6-8.95 3.84-13.47s7.41-5.74 13.14-5.74Z"
        className="Andorra_svg__cls-6"
      />
      <path
        id="Andorra_svg__path3008"
        d="M645 232.16h106.18v106H645Z"
        className="Andorra_svg__cls-7"
      />
      <path
        id="Andorra_svg__path2528"
        d="M486.52 286.36c3.09 1.62 6.22-.75 5.58-4.78a5.74 5.74 0 0 0-5.08-4.43"
        className="Andorra_svg__cls-8"
      />
      <path
        id="Andorra_svg__path2604"
        d="M486.41 286.29c2.92 2.11 6.66-1.45 5.21-5.23-1-2.55-4.6-5.3-9.63-1.89-5.55 3.77-4 15.67 6.63 15.87 9.5.18 15.27-13.66 6.83-23.37-8.12-9.35-22.9-7.17-32.54.51a43.12 43.12 0 0 0-14.27 23.47 44.6 44.6 0 0 0-1.18 10.24 45.83 45.83 0 0 0 7.19 23.62 23.5 23.5 0 0 0 2.63 3.3 49 49 0 0 0 3.82 3.92c5.45 4.54 12.48 8.1 21.09 7.74 9.45-.41 14.87-7 13.87-14.87-1-7.6-8.65-11.38-13.67-7.84-3.41 2.41-4.63 9.88 1.41 11.66 3.42 1 6.43-3.32 4-5.83"
        className="Andorra_svg__cls-8"
      />
      <path
        id="Andorra_svg__path2532"
        d="M681.41 539.9a5.4 5.4 0 0 1 1.51 1.93 9 9 0 0 1 .67 1.72 4.33 4.33 0 0 1-4 5.28 6.82 6.82 0 0 1-7.09-4.1"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2534"
        d="M499.34 456.48c.66.63.8 1.44 1.7 1.61 1.36.25 2.41.75 3.77-1.06 1.67-2.23.77-5.69-1-7.88s-7.25-4.4-11.77-1.88a15 15 0 0 0-5.12 4.21 38 38 0 0 0-2.31 3.22 25 25 0 0 0-2.2 5c-4.14 11.76.77 24.12 8.38 31.65"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2536"
        d="M681.16 539.66a12 12 0 0 1 1.31 1.6A8.3 8.3 0 0 1 683 543a4.33 4.33 0 0 1-4 5.28 6.45 6.45 0 0 1-6.81-4.08"
        className="Andorra_svg__cls-8"
      />
      <path
        id="Andorra_svg__path2538"
        d="M613.43 208.25c1.68-.94 3.24-1.82 4.68-2.61 2.13-1.17 4.69-.93 5.79.41a4.22 4.22 0 0 1-.29 5.7"
        className="Andorra_svg__cls-8"
      />
      <path
        id="Andorra_svg__path2540"
        d="M544.2 198.84a7.15 7.15 0 0 0 4.93 4.92 7.61 7.61 0 0 0 7.74-2.81c2-2.52 1.8-5.65 1.07-8.14a9.5 9.5 0 0 0-3.48-4.48l-10.26 10.41z"
        style={{
          fill: "none",
          stroke: "#713e2a",
          strokeLinejoin: "round",
          strokeWidth: "1.04px",
        }}
      />
      <path
        id="Andorra_svg__path2542"
        d="m553 187.25 1.41 1 1.5 1.61 1 2 .5 1.7.1 2.21-.1 1.51-.5 1.71-1 1.2-1.2 1.31-1.71.9-2.21.51-1.91.3-2-.91-1.81-1.3-1.07-1.59-.8-2v-.8Z"
        className="Andorra_svg__cls-6"
      />
      <path
        id="Andorra_svg__path2544"
        d="M589.29 219.55c11.09-2.32 20.13-7.28 27-11.11"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2546"
        d="M588.72 219c11.09-2.32 20.13-7.28 27-11.11"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2548"
        d="M654.78 557.13c-2.61 4-8.84 10-15.37 12.45-6.53-2.41-12.76-8.43-15.37-12.45"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2550"
        d="M749.39 182.33c5.45-3 9.65-2.41 12.76 1.9a20 20 0 0 1 3.11 14.58c-1.1 5.42-2.67 7.67-7 11.61"
        className="Andorra_svg__cls-8"
      />
      <path
        id="Andorra_svg__path2552"
        d="M762.55 184.74c6.23-4.12 13-2.37 16.68 3.12 2.71 4 3.4 7.38 3.21 12.35a22.69 22.69 0 0 1-11.55 18.59"
        className="Andorra_svg__cls-8"
      />
      <path
        id="Andorra_svg__path2554"
        d="M780.53 190.25c6.76.82 12.64 7.27 12.64 14.2 0 8.94-3 12.27-7.72 18.67C780.42 230 764 242.5 764 256.77c0 8.64 2.41 14.16 8.63 17 4 1.81 8.72-.15 10.85-2.08 5.23-4.73 3.14-13-2.31-14-6.63-1.2-7.87 9.24-1.4 8.54"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2556"
        d="M791.88 199.11a10.4 10.4 0 0 1 9.24 10.45c0 7.73-2.16 11.09-8.33 18.78-5.33 6.63-21.3 18.28-20.9 29.43.15 4.22 3.71 8.19 6.77 8.41"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2558"
        d="M792.48 286.29c-2.91 2.11-6.63-1.29-5-4.91 1.11-2.5 4.42-5.62 9.45-2.21 5.54 3.77 4 15.67-6.64 15.87-9.49.18-15.91-13.3-6.83-23.37 8.29-9.2 23.67-7.4 33.31.27 4.11 3.27 12.36 12.23 14.13 24 2.14 14.24 1.87 31.75-12.84 42.54-5.91 4.33-14.1 6.3-21.34 6-9.44-.42-14.86-7-13.86-14.87 1-7.6 8.29-10.81 13.66-7.84 5.58 3.09 4.61 10.94-1.4 11.66-3.54.42-6.43-3.32-4-5.83"
        className="Andorra_svg__cls-8"
      />
      <path
        id="Andorra_svg__path2560"
        d="M787.46 281.38c1.57-7.05 7.61-7.7 12.48-7.63 13.3.19 22.5 16 22.66 31.24.19 19.28-8.19 30.63-22.28 31.24-3.65.15-9.93-1.58-10-6"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2562"
        d="M795.65 278.23c14 3.12 19 15.76 19 27.82 0 9.84-1 23.29-20.13 28"
        style={{
          fill: "none",
          strokeWidth: ".99px",
          stroke: "#713e2a",
          strokeMiterlimit: 3.86,
          strokeLinecap: "square",
        }}
      />
      <path
        id="Andorra_svg__path2564"
        d="M803.94 354.51c-2.41-5.82-8.64-3.21-9 0-.88 7.41 5.61 9.65 10.23 8.44a8.05 8.05 0 0 0 5-3.92 10 10 0 0 0-.93-10.86 10.1 10.1 0 0 0-2.58-2.44c-1.78-1.13-3.72-1.24-6.75-1.24-11.25 0-21.1 13.29-24.4 27.1-1.09 4.55-2.59 14.69-.51 24.31a45.15 45.15 0 0 0 11.83 22.72c2.81 2.91 6.65 5.51 11.62 8.32a50 50 0 0 0 8.39 3.46 16 16 0 0 0 8 .19c6.66-1.45 9.76-7.65 6.4-14-2.75-5.19-10.84-8-14.66-1.4a6.4 6.4 0 0 0-.81 3.11c0 1.77.75 3.9 2 4.7 2.91 1.85 7.55 1.33 7.33-3.8"
        style={{
          fill: "none",
          strokeLinecap: "round",
          stroke: "#713e2a",
          strokeMiterlimit: 3.86,
          strokeWidth: "1.04px",
        }}
      />
      <path
        id="Andorra_svg__path2566"
        d="M812.68 423.71c-2.11.81-3.27.7-5.89-.47-1.08-.48-2.31-1.21-3.76-2-5.14-2.93-11.25-7.53-17-18.28a38 38 0 0 1-3.46-9 34.5 34.5 0 0 1-1-6.74 52.2 52.2 0 0 1 1.25-12.56c1.6-7.65 3.52-11.81 8.24-18.28 2.32-3.18 4.32-5.12 8.64-5.22"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2568"
        d="M818.79 413.48a7.89 7.89 0 1 0-12.65 4.73"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2570"
        d="M815.72 405.64a7.39 7.39 0 0 0-14.7 1.28 7.68 7.68 0 0 0 2.09 5.28"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2572"
        d="M801.32 405.23a31.36 31.36 0 0 1-12.55-24.9c0-8.37 3.31-16.88 7.23-20.19"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2574"
        d="M790.65 401.52c2.64 3.92 5.83 8.28 12.58 11.94"
        className="Andorra_svg__cls-8"
      />
      <path
        id="Andorra_svg__path2576"
        d="M769.16 430.91c2.26-2.66 7.43-6.64 13.36-7.37s11.24 1 16.58 3.88c10.41 5.6 16.21 11.62 20.09 22.8a34.8 34.8 0 0 1 1.68 11.65c-.18 7.24-2 15.16-4 19-1.73 3.33-6.23 18.08-30.94 28.25-14.43 5.94-36.57 7.31-51.84 7.91-21 .83-40.38 1.61-51.64 15.47"
        style={{
          fill: "none",
          stroke: "#713e2a",
          strokeMiterlimit: 3.86,
          strokeWidth: "1.28px",
        }}
      />
      <path
        id="Andorra_svg__path2578"
        d="M800.71 434.76c-6.62-4.34-19.18-10-30.53-4.43-4.21 2.08-7 4.65-8.62 8.84-2.87 7.54.34 15.86 3.6 19.31 1.71 1.81 5.43 5.27 10.05 5.33 7.63.1 9.45-5.25 9.64-6.43.9-5.53-2.31-7.74-4-8.34-1.31-.46-5.57-.34-6.47 2.67a5.37 5.37 0 0 0 .44 4.06"
        className="Andorra_svg__cls-8"
      />
      <path
        id="Andorra_svg__path2580"
        d="M774.4 454.67c-.6-2.21 0-4.33 1.71-6.73 2.34-3.22 7.33-4.33 11.85-1.81a15 15 0 0 1 5.13 4.21c.65.87 1.74 2.25 2.31 3.22a25 25 0 0 1 2.2 5c5 14.12-2.93 29.42-13.25 35.57-8 4.76-17.59 6.89-29 8.23-5.15.6-8.09.57-13.27.81-4.16.19-7.76.12-11.14.08-2.79 0-5.44 0-8.14-.08a140 140 0 0 0-14.57.2c-5.88.42-10.3.57-15.27 1.4-3.24.54-7 1.07-11 2-1.2.27-2.42.49-3.63.86l-2.43.74c-7.2 2.19-14.2 4.87-19.72 8.42a36 36 0 0 0-5 3.5c-.86.81-1.9 1.63-2.74 2.45-3.86 3.8-7.82 7.92-8.74 13.49a20 20 0 0 0-.17 3.24c0 3.62 2.94 8.54 10.88 10.14"
        className="Andorra_svg__cls-14"
      />
      <path
        id="Andorra_svg__path2582"
        d="M681.68 540.86c2.11 4.32-.29 6.49-3.21 6.83-4.32.5-6.63-2.92-6.93-6a8.86 8.86 0 0 1 8.84-9.54 11.22 11.22 0 0 1 10 7.07 14.1 14.1 0 0 1 1 4.78 11.77 11.77 0 0 1-2.88 8.36 15.14 15.14 0 0 1-10.89 5c-8.52.34-15.17-7.63-15.17-15.77 0-15.57 23.1-24.06 32.25-26.25 11.25-2.68 18.1-3.69 36.17-4.69 7.23-.4 12.52-.2 20.49-1a122 122 0 0 0 18.18-2.8 55 55 0 0 0 25.32-12.86c5.87-5.33 9.24-9.14 12-16.47 2.35-6.33 3.43-18.86-2.52-28.13a28.94 28.94 0 0 0-20.9-13.65c-7.53-1.09-14.13 2.16-18.08 9.63-1.91 3.62-1.32 9.67.19 12.46 1.31 2.41 5 6 9.66 6 7.63.1 9.45-5.25 9.64-6.43.9-5.53-2.31-7.74-4-8.34-1.31-.46-5.57-.34-6.47 2.67a5.37 5.37 0 0 0 .44 4.06"
        className="Andorra_svg__cls-8"
      />
      <path
        id="Andorra_svg__path2584"
        d="M675.1 516.12c-9.79 4.34-17 7.59-23.05 17.2-1.91 3-2.41 7.33-2.41 9.85 0 5.42 2.21 11.55 6.73 15.37a16.69 16.69 0 0 0 13.46 4.11c3.88-.38 7.53-3.21 8.13-5.22"
        className="Andorra_svg__cls-8"
      />
      <path
        id="Andorra_svg__path2586"
        d="M769.28 271.74a14.36 14.36 0 0 0-5.28 11.55c0 6.25 5.23 16.47 18.09 20.09 4.92 1.39 9.63 1.26 12.58-.54"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2588"
        d="M771.79 330.3c-4.58 1.53-7.83 8.51-7.83 15.17 0 7.64 3.71 12.36 8 15.07"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2590"
        d="M776.81 355.11c-8.23 10.25-12.6 16.33-12.85 28.53-.24 11.45 3.41 19.29 10.24 27.53"
        className="Andorra_svg__cls-8"
      />
      <path
        id="Andorra_svg__path2592"
        d="m732.91 184.78.71-1c3.41-5 9.44-6.35 13.86-3 5.32 4 6.67 10.85 5.23 18.08-.91 4.52-4 8.28-8.18 11"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2594"
        d="M549.92 195.11c-.62-3.34-4.52-4-6-2.05-2.33 3-.63 8.09 4.1 9.56a7.59 7.59 0 0 0 7.74-2.81c1.95-2.52 1.8-5.65 1.07-8.13a9.07 9.07 0 0 0-3.48-4.33c-5.5-4.17-14.37-3.21-17.28 3.82-3.76 9.07 4.42 15.87 12 21 9.49 6.45 20.29 7.62 28.43 7.53 18.48-.2 32.55-9 41.69-14.06 2.13-1.17 4.32-.93 5.42.4a4 4 0 0 1-.5 5.52"
        className="Andorra_svg__cls-15"
      />
      <path
        id="Andorra_svg__path2596"
        d="M529.51 182.33c-5.23-2.41-9.53-1.94-12.76 1.9-3.72 4.42-3.86 10.92-3.11 14.58 1.1 5.42 2.67 7.67 7 11.61"
        className="Andorra_svg__cls-8"
      />
      <path
        id="Andorra_svg__path2598"
        d="M516.35 184.74c-6.23-4.12-13-2.37-16.68 3.12-2.71 4-3.4 7.38-3.21 12.35A22.69 22.69 0 0 0 508 218.8"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2600"
        d="M498.37 190.25a13.76 13.76 0 0 0-12.15 13.48c0 8.94 2.2 12.56 7.22 19.39s21.5 19.38 21.5 33.65c0 8.64-2.41 14.16-8.64 17-4 1.81-8.71-.15-10.85-2.08-5.22-4.73-3.13-13 2.31-14 6.63-1.2 7.88 9.24 1.41 8.54"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2602"
        d="M487 199.11c-5.13.4-10.17 4.81-10.17 10.22 0 7.73 3.08 11.32 9.26 19 5.32 6.63 20.37 18 20 29.2-.15 4.22-3 9.38-5.8 8.77"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2982"
        d="M479.63 282a18.84 18.84 0 0 0-9.76 7c-2.4 3.4-3.8 8.12-4.66 12.25a40.2 40.2 0 0 0 .32 13.45 31.8 31.8 0 0 0 4.66 11.3 15.6 15.6 0 0 0 2.09 2.5 22 22 0 0 0 2.29 1.77"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2606"
        d="M475 354.51c2.41-5.82 8.64-3.21 9 0 .89 7.41-5.6 9.65-10.23 8.44a8.06 8.06 0 0 1-5-3.92 9.75 9.75 0 0 1-.79-7.52 10 10 0 0 1 1.72-3.34 10.1 10.1 0 0 1 2.58-2.44c1.78-1.13 3.71-1.24 6.75-1.24 11.25 0 21.09 13.29 24.4 27.1 1.09 4.55 2.59 14.69.51 24.31a45.3 45.3 0 0 1-11.83 22.72c-2.82 2.91-6.65 5.51-11.62 8.32a50 50 0 0 1-8.39 3.46 14.2 14.2 0 0 1-8 .19c-5.71-1.72-9.38-7.06-6.41-14 2.32-5.4 10.85-8 14.67-1.4a6.5 6.5 0 0 1 .81 3.11c0 1.77-.76 3.9-2 4.7-2.9 1.85-7.54 1.33-7.33-3.8"
        className="Andorra_svg__cls-8"
      />
      <path
        id="Andorra_svg__path2608"
        d="M466.22 423.71c2.11.81 3.26.7 5.89-.47 1.08-.48 2.31-1.21 3.75-2 5.15-2.93 11.25-7.53 17-18.28a37.8 37.8 0 0 0 3.45-9 33 33 0 0 0 1-6.74 52.2 52.2 0 0 0-1.24-12.56c-1.6-7.65-3.52-11.81-8.24-18.28-2.32-3.18-4.32-5.12-8.64-5.22"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2610"
        d="M460.11 413.48a7.89 7.89 0 1 1 12.64 4.73"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2612"
        d="M463.17 405.64a7.39 7.39 0 0 1 14.7 1.28 7.67 7.67 0 0 1-2.08 5.28"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2614"
        d="M477.57 405.23a31.37 31.37 0 0 0 12.56-24.9c0-8.37-3.32-16.88-7.23-20.19"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2616"
        d="M488.25 401.52c-2.64 3.92-5.84 8.28-12.59 11.94"
        className="Andorra_svg__cls-8"
      />
      <path
        id="Andorra_svg__path2618"
        d="M508.31 430.35c-1.87-4.41-5.59-6.44-11.65-7.09s-11.24 1-16.58 3.88c-10.41 5.6-16.22 11.62-20.09 22.79a34.7 34.7 0 0 0-1.68 11.66c.18 7.24 2 15.16 4 19 1.73 3.34 6.23 18.09 30.94 28.26 14.42 5.94 36.57 7.3 51.84 7.91 21 .83 40.38 1.6 51.63 15.47"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2620"
        d="M478.19 434.76c6.61-4.34 19.17-10 30.52-4.43 4.21 2.08 7 4.65 8.63 8.84 2.87 7.54-.34 15.86-3.6 19.31-1.71 1.81-5.43 5.27-10.05 5.33-7.63.1-9.45-5.25-9.64-6.43-.91-5.53 2.31-7.74 4-8.34 1.32-.46 5.58-.34 6.48 2.67a5.37 5.37 0 0 1-.45 4.06"
        className="Andorra_svg__cls-8"
      />
      <path
        id="Andorra_svg__path2622"
        d="M504.49 454.67a6.79 6.79 0 0 0-1.7-6.73c-2-2.22-7.34-4.33-11.86-1.81a15 15 0 0 0-5.12 4.21c-.65.87-1.75 2.25-2.31 3.22a25 25 0 0 0-2.2 5c-5 14.12 3.12 29.12 13.25 35.57 8.84 5.62 17.88 7.23 29 8.23 5.16.47 8.09.57 13.26.81 4.17.19 7.76.12 11.15.08 2.79 0 5.43 0 8.14-.08a140 140 0 0 1 14.56.2c5.88.42 10.31.57 15.27 1.4 3.25.54 7 1.07 11 2 1.2.27 2.41.49 3.63.86l2.43.74c7.2 2.19 14.2 4.87 19.71 8.42a30.5 30.5 0 0 1 5 3.5c1 1 1.91 1.63 2.75 2.45 3.86 3.8 7.81 7.92 8.74 13.49a20 20 0 0 1 .17 3.24c0 3.62-3 8.54-10.88 10.14"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2624"
        d="M597.22 540.86c-2.11 4.32.28 6.49 3.21 6.83 4.32.5 6.63-2.92 6.93-6a8.87 8.87 0 0 0-8.84-9.54 11.19 11.19 0 0 0-10 7.07 13.8 13.8 0 0 0-1 4.78 11.8 11.8 0 0 0 2.87 8.36 15.16 15.16 0 0 0 10.89 5c8.53.34 15.17-7.63 15.17-15.77 0-15.57-23.09-24.06-32.24-26.25-11.26-2.68-18.1-3.69-36.17-4.69-7.23-.4-12.53-.2-20.49-1a121.7 121.7 0 0 1-18.18-2.8A54.9 54.9 0 0 1 484 493.94c-5.88-5.33-9.24-9.14-12-16.47-2.35-6.33-3.43-18.86 2.52-28.13a28.92 28.92 0 0 1 20.89-13.65c7.54-1.09 14.14 2.16 18.09 9.63 1.9 3.62 1.32 9.67-.2 12.46-1.3 2.41-5 6-9.65 6-7.63.1-9.45-5.25-9.64-6.43-.91-5.53 2.31-7.74 4-8.34 1.32-.46 5.58-.34 6.48 2.67a5.37 5.37 0 0 1-.45 4.06"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2626"
        d="M603.8 516.12c9.79 4.34 17 7.59 23.05 17.2 1.91 3 2.41 7.33 2.41 9.85 0 5.42-2.21 11.55-6.73 15.37a16.7 16.7 0 0 1-13.46 4.11c-3.89-.38-7.54-3.21-8.14-5.22"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2628"
        d="M509.62 271.74a14.36 14.36 0 0 1 5.32 11.55c0 6.25-5.23 16.47-18.09 20.09a16.66 16.66 0 0 1-12.75-1.53"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2630"
        d="M511.73 292.93c2.31 1.61 3.21 3.42 3.21 6.55 0 2.15-1.39 4.94-3.76 7.58a24.92 24.92 0 0 1-17.72 8.09 20.62 20.62 0 0 1-12.17-3.53 18.33 18.33 0 0 1-7.74-10.85"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2632"
        d="M511.52 306.41c2.62 2.4 3.42 5.42 3.42 9.21 0 5.54-2.25 9.82-7.43 14.35a25.7 25.7 0 0 1-3.92 2.82"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2634"
        d="M507.11 330.3c5.52 4.32 7.83 8.51 7.83 15.17 0 7.64-3.72 12.36-8 15.07"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2636"
        d="M502.08 355.11c8.24 10.25 12.61 16.33 12.86 28.53.24 11.45-3.41 19.29-10.25 27.53"
        className="Andorra_svg__cls-8"
      />
      <path
        id="Andorra_svg__path2638"
        d="m546 184.78-.71-1c-3.42-5-9.45-6.35-13.86-3-5.33 4-6.67 10.85-5.23 18.08.91 4.52 4 8.28 8.17 11"
        className="Andorra_svg__cls-8"
      />
      <path
        id="Andorra_svg__path2640"
        d="M734.72 200c-8.14 8.84-16.28 11.66-28.43 12.06-3.79.12-11-1.21-15.27-4.21-2.71-1.93-5.73-5.24-3.82-11 1.28-3.83 7.43-14.57 7.73-22 .46-11.36-3.91-17.58-10.74-20-12.63-4.46-26.19 8-34.36 10.75a27.5 27.5 0 0 1-10.34 1.6 28 28 0 0 1-10.43-1.6c-8.17-2.73-21.72-15.21-34.35-10.75-6.83 2.41-11.2 8.63-10.74 20 .3 7.43 6.45 18.17 7.72 22 1.91 5.72-1.1 9-3.81 11-4.22 3-11.48 4.33-15.27 4.21-12.16-.4-20.3-3.22-28.43-12.06"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2642"
        d="M661.49 206.14c1.66 3 2.57 4.83 1.61 7.94-1.1 3.51-3.59 5.62-7.13 5.62-8 0-12.77-9.51-9.15-15.57 6.43-10.75 18.79-4.71 30.24.61-.55-2.75-1.52-3.65-1.42-7.07.25-8.48 6.54-12.32 9.06-20.16 1.49-4.67 2.09-8.72-1.33-12-3-2.89-6.44-2.85-10.33-1.32-7.77 3-17.11 11.81-33.55 12-16.44-.24-25.86-9-33.64-12-3.89-1.53-7.34-1.57-10.33 1.32-3.41 3.32-2.81 7.37-1.32 12 2.51 7.84 8.8 11.68 9 20.16.1 3.42-.86 4.32-1.41 7.07 11.45-5.32 24.28-11.9 30.23-.61 3.32 6.29-1.1 15.57-9.14 15.57-3.54 0-6-2.26-7.13-5.62-1-3 0-5.63 1.61-7.94"
        className="Andorra_svg__cls-14"
      />
      <path
        id="Andorra_svg__path2646"
        d="M603.47 204a12.8 12.8 0 0 0 .92-5.19c-.25-8.48-6.54-12.32-9-20.16-1.5-4.67-2.09-8.72 1.33-12 3-2.89 6.43-2.85 10.32-1.32 7.78 3.05 17.2 11.81 33.64 12.05-16.44-.24-25.86-9-33.64-12.05-3.89-1.53-7.66-2-10.65.92-3.41 3.32-2.5 7.77-1 12.44 2.51 7.84 8.48 11.68 8.73 20.16A12.5 12.5 0 0 1 603 204"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2648"
        d="M640.58 176.76c16.17-.85 30-11.72 34.5-12.6 4-.79 6.22-.44 9.14 2.22-2.92-2.66-6.25-2.57-10-1.09-7.77 3.05-17.11 11.81-33.55 12.05"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2650"
        d="M660 219.66a8.37 8.37 0 0 0 3.22-4.5c1-3 1-5.57-.61-7.88 2 2.59 2.16 4.78 1.61 7.93-.36 2-1.64 3.07-3.23 4.51"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2654"
        d="M764.9 393.66v32.61h.1a49 49 0 0 1-.27 5c-.17 1.27-.35 2.42-.55 3.5"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2656"
        d="M764.33 390.53v35.17h.08a49 49 0 0 1-.27 5 54 54 0 0 1-.94 5.33"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2658"
        d="M764.33 349.35v29.33"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2660"
        d="M764.9 351.66v23.86"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2662"
        d="M764.9 321.32v17.88"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2664"
        d="M764.33 319.21v22.05"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2666"
        d="M764.9 303v7"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2668"
        d="M764.33 301.63v10.05"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2670"
        d="M764.9 288.22v7.13"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2672"
        d="M764.33 286.46v10.05"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2674"
        d="M764.9 264.71v13.16"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2676"
        d="M764.33 261.8v18"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2678"
        d="M760.49 445.26a37.8 37.8 0 0 1-8.44 11.45A39.6 39.6 0 0 1 740.3 465c-4.87 2.44-7.94 3.21-13.26 4.42a67.4 67.4 0 0 1-13.87 1.7 94 94 0 0 1-12.8-.33c-5.33-.36-8.29-1.11-13.61-1.57a107 107 0 0 0-11.3-.74 58.6 58.6 0 0 0-11.61.83 44.6 44.6 0 0 0-10.45 2.92c-5.42 2.2-11.55 6-12.85 7.73-1.31-1.7-7.44-5.53-12.86-7.73a44.6 44.6 0 0 0-10.45-2.92 58 58 0 0 0-11.61-.83 107 107 0 0 0-11.3.74c-5.32.46-8.28 1.21-13.61 1.57a94 94 0 0 1-12.8.33 67.4 67.4 0 0 1-13.87-1.7c-5.31-1.21-8.38-2-13.26-4.42a39.7 39.7 0 0 1-11.79-8.29l-1.23-1.23"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2680"
        d="m760.61 443.29-.69 1.4a37.7 37.7 0 0 1-8.44 11.45 39.6 39.6 0 0 1-11.75 8.24c-4.87 2.44-7.94 3.22-13.26 4.42a67.3 67.3 0 0 1-13.86 1.7 96 96 0 0 1-12.81-.32c-5.33-.37-8.29-1.12-13.61-1.58a107 107 0 0 0-11.3-.74 58 58 0 0 0-11.61.84 44 44 0 0 0-10.45 2.91c-5.42 2.2-11.55 6-12.85 7.73-1.31-1.71-7.44-5.53-12.86-7.73a44 44 0 0 0-10.45-2.91 58 58 0 0 0-11.61-.84 107 107 0 0 0-11.29.74c-5.33.46-8.29 1.21-13.62 1.58a96 96 0 0 1-12.8.32 67.4 67.4 0 0 1-13.87-1.7c-5.31-1.21-8.38-2-13.26-4.42a39.7 39.7 0 0 1-11.75-8.24 45 45 0 0 1-5-5.63"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path3010"
        d="M750.78 430a26.8 26.8 0 0 1-2.79 8.54c-1.91 3-1.21 2.93-5.52 7.76a31.1 31.1 0 0 1-8.05 5.8 34.7 34.7 0 0 1-8.84 3.23 65.9 65.9 0 0 1-21.42 2.06 128 128 0 0 1-13.24-1.37 141 141 0 0 0-14.36-1.31c-2.76-.11-5.36-.14-7.94 0a68 68 0 0 0-9.44 1.31 107 107 0 0 0-14.26 4.12L645 349.5h106.2v75.64s-.22 3.69-.42 4.92Z"
        className="Andorra_svg__cls-7"
      />
      <g id="Andorra_svg__use4034">
        <path
          id="Andorra_svg__path3018"
          d="m672.16 405.63-.77.36a10 10 0 0 1-1 1.05 16 16 0 0 1-1.61 1.09 3.1 3.1 0 0 0-.77.56c-.32.42-.1.82-.32 1.3a4.8 4.8 0 0 1-.85 1.21 14 14 0 0 1-1.37 1.29 6.2 6.2 0 0 1-1.42 1.29 1.6 1.6 0 0 1-.44.24c-.28.09-.45 0-.73.08-.5.18-.66.73-1 .93.15.29.14.48.29.77s.91 1.57 1.05 1.86.35.9.68 1a4.1 4.1 0 0 0 1.7.16 13.7 13.7 0 0 1 2.62.6c.8.33 1.12.75 1.9 1.09a6.5 6.5 0 0 0 1.66.57 3.8 3.8 0 0 0 1.29.12c.32 0 .49-.15.81-.2h.12v.56h.08l2.66 1.18a2.7 2.7 0 0 0-.24.48 2.15 2.15 0 0 0-.08 1.09c.81 2.44 1.5 4 1.9 4.12.79.3 1 1.12 1.49 1.94-.16.17-.29.26-.44.4a11.2 11.2 0 0 0-2.14 2.34c-1 1.54-1.62 1.56-.41 3.59.71 1.2 1.06 1.43 2 3.12a10.3 10.3 0 0 1 1 2.54 10 10 0 0 1 .41 2.54l1.25.49.84-.85.81-1.54v-1.17a1 1 0 0 1-.32-1c.09-.47.67-.37.93-.8.37-.6-.43-.95-.85-1.42-.78-.86-1.85-1.07-2.1-2.38-.07-.35.1-.55.49-.93 1.1-1.08 1.46-1.26 2.54-2.34a1.83 1.83 0 0 0 1.25.16c.36-.07.69.16 1.82.49a2.9 2.9 0 0 0 1.57 0l.49-.12a5 5 0 0 1 .16.88c.07 1.37-.2 3.87.2 4.53a3.7 3.7 0 0 1 .36.72 2.3 2.3 0 0 1 .29.85c0 .9.06 1.47 0 2.42a20 20 0 0 1-.29 2.26 2.57 2.57 0 0 1-.56 1.38c-.37.47-.77.54-1.25.89l-.12 1.29 1.45.6 1.66.41.88-.37a1.4 1.4 0 0 1 .21-.8c.16-.32.29-.57.6-.69.47-.18 1 .17 1.17-.12s.08-.44 0-1c-.06-.86-.23-1.28-.36-2.14a15.3 15.3 0 0 1-.2-3.55 12.4 12.4 0 0 1 .2-2c.22-1.14.63-1.7.89-2.83a28 28 0 0 0 .48-3.19 31.4 31.4 0 0 0 12.07-.48c.22-.05 1-.33 1-.33a11.1 11.1 0 0 0 3.52 2.1v1.25c0 .38-.06.63.16.93a.74.74 0 0 0 .48.37.84.84 0 0 0 .85-.21c.29-.25.24-.58.32-1a4.4 4.4 0 0 0 0-.89 6 6 0 0 0 1.13.08 7 7 0 0 0 1.13 0c0 .1 0 .48.05.6 0 .32-.1.56 0 .85a.82.82 0 0 0 .64.53.84.84 0 0 0 .69-.13c.38-.23.34-.64.4-1.08a9 9 0 0 0 0-1c.28-.08 1.07-.37 1.33-.48a6 6 0 0 1-.12 1.05 6 6 0 0 1-.32 1.21 9.3 9.3 0 0 1-1 1.78 16 16 0 0 1-1.33 2c-.27.34-.47.5-.73.85s-.44.73-.77 1.17a6 6 0 0 1-1.21 1.37c-.89.71-1.48.14-2.7 1.09l-.28 1.33 1.85.69 1.66.32.56-.32a1.3 1.3 0 0 1 .29-1 1.42 1.42 0 0 1 1-.53c.46-.07 1 .05 1.33-.28s.45-1.18.8-1.9a16.4 16.4 0 0 1 3.88-5c.79-.77 1.47-1 2.14-1.86.32-.42.67-.61.69-1.13s-.19-.54-.28-.89a12 12 0 0 1-.25-1.29c2 1 1.26.83 1.62 1.81.29.8 0 1.35.08 2.19s.6 1.44.69 2.42a9.6 9.6 0 0 1-.41 3 9.4 9.4 0 0 1-.6 2.58 5 5 0 0 1-1.5 2 8 8 0 0 1-.76.52l-.17 1.34 1.46.48 2.1.57.48-.45c.21-.85-.07-2.09.53-2.18s.89 0 1-.4c0-.17.07-.42.12-.81.28-2.44.54-4.71.8-5.81s.28-1.53.53-2.47a8.5 8.5 0 0 1 .52-2.18c1-2.71-.26-3.07-1.37-4.72a3.9 3.9 0 0 1-.89-1.94c-.12-1.06.22-1.93.16-3.55s0-2.79 0-3.72l.45-.24a5.29 5.29 0 0 0 3.07-3.19 4.4 4.4 0 0 0 .4-1.9c0-.43-.08-.84-.12-1.33a3.7 3.7 0 0 0-.4-1.21 4.2 4.2 0 0 0-.73-1.09c-1-1.2-2.3-1.46-3.51-1.9-1.92-.69-3.24-.56-5.33-.73a34 34 0 0 0-5.54-.07c-2.59.14-4 .66-6.62 1a56 56 0 0 1-6.34.53c-2.92.05-5.71-.6-7.47-.45-3.16.27-3.22 1-8 1.38-2.49.2-5 .24-5 .24l-2.78-.89a3.12 3.12 0 0 0 1.89-1.33c.36-.47.31-.88.73-1.37s.57-.81 1-1.26a2.86 2.86 0 0 0-1.21-.56 3.1 3.1 0 0 0-1.21 0 4.2 4.2 0 0 0-1.58.44 3.8 3.8 0 0 0-1.09.77 26 26 0 0 0-2.82-1.58 12 12 0 0 0-3.88-1.17ZM674.7 421h.09Z"
          className="Andorra_svg__cls-16"
        />
      </g>
      <path
        id="Andorra_svg__path2682"
        d="M494.87 454.5a5 5 0 1 1 5 5 5 5 0 0 1-5-5Z"
        className="Andorra_svg__cls-17"
      />
      <path
        id="Andorra_svg__path2684"
        d="M495.12 445.48 491 447l-4.22 3.21-1.78 2.5-2.31 4-1 3-.8 3.71-.4 2.81"
        className="Andorra_svg__cls-18"
      />
      <path
        id="Andorra_svg__path2686"
        d="M519.43 444.07c.86 6.39-1.83 12.67-4.55 15.55-1.71 1.81-5.43 5.27-10.05 5.33-7.64.1-9.91-5.16-10.38-6.43"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2688"
        d="m518.82 445.88-.3 3.62-.6 2.51-1.81 4.32-2.81 3.72-3 2.41-2.21 1.1-3.12.7"
        className="Andorra_svg__cls-18"
      />
      <path
        id="Andorra_svg__path2690"
        d="M510.37 440.77a21 21 0 0 1 3.73 5.12c1.91 3.62 1.33 9.67-.19 12.46a8.5 8.5 0 0 1-.61 1"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2692"
        d="M472.43 495.69c4.54 4.76 11.41 9.94 21.95 14.28 14.42 5.94 36.57 7.3 51.84 7.91 20.3.8 39 1.63 50.4 14.21"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2694"
        d="M631.67 523.86c3.35 3.31 6.78 6.84 8.22 11.37"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2696"
        d="M639.82 542.24c-.75 3.35-3.88 7.17-10.69 8.55l-1.33.28"
        style={{
          fill: "none",
          stroke: "#713e2a",
          strokeMiterlimit: 3.86,
          strokeWidth: "1.2px",
        }}
      />
      <path
        id="Andorra_svg__path2698"
        d="M629.08 549.34a20 20 0 0 1-4.49 8.33"
        className="Andorra_svg__cls-8"
      />
      <path
        id="Andorra_svg__path2700"
        d="M594.58 512.58c1.61.62.39-.39 10.59 4.13 9.79 4.34 16.73 8.14 22.82 17.75 1.91 3 2.41 7.33 2.41 9.84a22 22 0 0 1-.59 5"
        className="Andorra_svg__cls-8"
      />
      <path
        id="Andorra_svg__path2702"
        d="M625.07 558.34a16 16 0 0 1-1.4 1.33 16.68 16.68 0 0 1-13.46 4.12c-3.89-.38-7.63-3.29-8.64-5.2"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2704"
        d="m629.73 545.13-.91 4.42"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2706"
        d="m624.1 558-1.91 1.91-3.41 1.91-3.92 1.2"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2708"
        d="M655.35 557.7c-2.61 4-8.84 10-15.37 12.46-6.53-2.41-12.76-8.44-15.37-12.46"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2710"
        d="M655.92 558.27c-2.62 4-8.85 10-15.37 12.46-6.53-2.42-12.76-8.44-15.37-12.46l-.61-.94"
        style={{
          fill: "none",
          stroke: "#221f1f",
          strokeMiterlimit: 3.86,
          strokeWidth: ".99px",
        }}
      />
      <path
        id="Andorra_svg__path2712"
        d="m613 563.21 3.62-.45"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2714"
        d="M590.77 552.73c.19.26.38.5.59.74a15.4 15.4 0 0 0 10.31 5"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2716"
        d="M595.24 556.23a16 16 0 0 0 6.56 1.67c8.53.34 15.17-7.64 15.17-15.77 0-5.64-3.07-10.39-7.37-14.21"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2718"
        d="M597.08 540.84c-2.06 4.59.87 7.08 3.8 7.42 4.32.5 6.75-2.92 7-6a9 9 0 0 0-4.23-8.38"
        className="Andorra_svg__cls-8"
      />
      <path
        id="Andorra_svg__path2722"
        d="M655.92 558.27c-2.62 4-8.85 10-15.37 12.46-6.53-2.42-12.76-8.44-15.37-12.46l-.61-.94"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2730"
        d="M656 558.24a17.69 17.69 0 0 0 15 5.55 11 11 0 0 0 8.21-5.22 4.4 4.4 0 0 0 .9-1.47"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2732"
        d="m678.79 557.43-1.5 2.41-2.29 1.89-3.45 1.43-3.13.13"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2734"
        d="M686.9 534.47a15.6 15.6 0 0 1 4.65 5.86 14 14 0 0 1 1 4.78 11.73 11.73 0 0 1-2.87 8.36 15.14 15.14 0 0 1-10.89 5h-.95"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2736"
        d="M678.23 557.9a13.8 13.8 0 0 1-10.45-4.36"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2738"
        d="m677.68 558 3.65-.34 3.48-1.39 2.43-1.48 3.31-3.91.69-1.48.52-3.39.18-1.56"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2742"
        d="M810.37 435.43c4.31 4 7.34 8.92 9.67 15.65a34.6 34.6 0 0 1 1.69 11.65c-.18 7.24-2 15.16-4 19-1.72 3.34-6.23 18.08-30.94 28.26-14.42 5.94-36.56 7.3-51.83 7.91-20.71.81-39.83 1.58-51.15 14.88"
        className="Andorra_svg__cls-21"
      />
      <path
        id="Andorra_svg__path2744"
        d="m683.07 532.17 3.62-3.31 2.51-1.86 4.72-2.91 4.42-2.11 3.11-.81 6.23-1.4 7.23-1.11"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2746"
        d="M776.59 448.84c1.54-2.1 7.13-4.75 11.65-2.24a12.6 12.6 0 0 1 4.8 4.19"
        style={{
          fill: "none",
          stroke: "#713e2a",
          strokeMiterlimit: 3.86,
          strokeWidth: ".93px",
        }}
      />
      <path
        id="Andorra_svg__path2748"
        d="M528.09 471.42c1-1.13 1.84-.71 2-1.22s-.17-.43-.59-.59-1.18-.33-1.74-.55-1.13-.52-1.72-.74c-.24-.09-.81-.38-1 .05-.29.79 2.07.72 1.28 2.85a7.6 7.6 0 0 1-1.65 2.42l-5.35 5.82c-.12.14-.32.42-.44.38s-.11-.4-.11-.58l.08-8.26a11.2 11.2 0 0 1 .39-3.41c.36-.94 1.45-.15 1.68-.76.14-.38 0-.4-.62-.64-.32-.13-1-.26-2.25-.74-.69-.26-1.35-.61-2-.86-.3-.11-.86-.53-1.07 0-.06.16.16.4.21.44a1.91 1.91 0 0 1 1 1.9l.14 15c0 1.08.13 1.38.34 1.46s.37 0 .82-.52l10.6-11.5Z"
        className="Andorra_svg__cls-23"
      />
      <path
        id="Andorra_svg__path2750"
        d="M534.32 473.75c.69-2.19 2-.87 2.23-1.65.09-.28 0-.35-.62-.55-1.18-.37-2-.52-2.7-.75s-1.5-.58-2.31-.83c-.19-.06-.68-.29-.81.1-.25.81 2.29.9 1.63 3l-3.48 11c-.69 2.18-2 1.11-2.24 1.92a.25.25 0 0 0 .14.35c.54.16 1.46.35 2.35.63 1.61.51 2.35.85 3.11 1.09.48.15.69.11.77-.14.23-.74-2.42-.41-1.52-3.24l3.45-11Z"
        className="Andorra_svg__cls-23"
      />
      <path
        id="Andorra_svg__path2752"
        d="M541.8 476c.41-1.39 1.06-1.2 1.83-1 2.1.63 2.76 2.68 2.09 4.94-.41 1.37-.92 2.63-4.08 1.69-.62-.18-1.39-.41-1.22-1Zm-5.73 9.95c-.86 2.91-2.32 1.64-2.54 2.39-.13.46.32.52.55.59 1 .3 2.11.52 3.23.85.88.26 1.41.52 1.77.62s.68.06.74-.15c.25-.83-2.09-.5-1.36-3l1.19-4c.24-.81.16-1 1.26-.68s1.35.63 1.53 1.78l.66 4.18c.25 1.53.49 3.18 2.13 3.67.83.24 2.36.14 2.57-.57a.33.33 0 0 0-.22-.42c-.2-.06-.45 0-.66-.05a.79.79 0 0 1-.64-.59c-.64-3.35-1.41-7.23-1.37-7.37s.73-.26 1.49-.61a3.83 3.83 0 0 0 2.06-2.53c.32-1.07.87-4.45-3.69-5.8-1.39-.41-2.83-.74-4.23-1.15s-1.44-.53-2.4-.81c-.25-.08-.49 0-.56.21-.25.83 2.27.65 1.51 3.23l-3 10.17Z"
        className="Andorra_svg__cls-23"
      />
      <path
        id="Andorra_svg__path2754"
        d="M553.08 490.88c-.67 2.79-2.78 1.09-3 2-.12.52.24.58.62.67.84.2 1.56.28 3 .62s2.08.6 2.93.8c.61.15 1 .32 1.15-.25s-2.71-.62-2-3.5l2.55-10.6c.27-1.12.51-1.19 1.37-1l1.8.43c2.44.49 1.15 2.93 2 3.13.55.13.54-.84.56-1.13l.29-2.21c0-.24.11-.57-.21-.65-2-.47-3.4-.71-6.47-1.45s-4.48-1.17-6.44-1.65c-.31-.07-.39.26-.47.49l-1.08 3c-.12.29-.37.78.08.89.95.22 1-3 3.43-2.43l1.78.43c.86.21 1 .37.77 1.5l-2.61 10.88Z"
        className="Andorra_svg__cls-23"
      />
      <path
        id="Andorra_svg__path2756"
        d="M578.7 484.33c.84-1.29 1.69-1 1.79-1.55s-.23-.39-.68-.47-1.21-.13-1.81-.24-1.2-.32-1.82-.43c-.25-.05-.86-.24-.94.21-.16.83 2.16.36 1.75 2.58a7.5 7.5 0 0 1-1.2 2.67l-4.26 6.67c-.1.15-.24.47-.37.44s-.17-.37-.21-.55l-1.36-8.14a11.2 11.2 0 0 1-.2-3.43c.18-1 1.4-.4 1.52-1 .07-.4 0-.4-.72-.53-.34-.06-1-.08-2.35-.33-.72-.13-1.43-.36-2.13-.5-.32-.05-1-.37-1.05.2 0 .17.22.36.28.4a1.89 1.89 0 0 1 1.27 1.7l2.79 14.74c.2 1.07.37 1.35.58 1.39s.37-.08.72-.65Z"
        className="Andorra_svg__cls-23"
      />
      <path
        id="Andorra_svg__path2758"
        d="M579.91 497.92c0 .59 0 .77.47 1a15.4 15.4 0 0 0 3.49 1.49c2.8.46 5.12-1.32 5.64-4.44s-.73-4.27-2.83-5.78c-2.64-1.88-3.76-2.38-3.5-4a2.31 2.31 0 0 1 2.8-2.1c3.68.62 3.26 5.1 3.75 5.18s.58-.2.63-.73l.3-3.22c.05-.56.17-.9-.15-1s-.88.25-1.16.2c-.64-.11-1.38-1.18-3.14-1.48-2.5-.42-4.55 1.29-5 4-.42 2.5.69 3.63 2.37 4.84 3.17 2.27 4.46 2.8 4.13 4.82a2.89 2.89 0 0 1-3.47 2.55c-2.37-.39-3.34-2.78-3.64-5.18 0-.32 0-.54-.38-.6-.54-.09-.44.64-.43 1Z"
        className="Andorra_svg__cls-23"
      />
      <path
        id="Andorra_svg__path2760"
        d="M611.86 488.91c.69-1.38 1.57-1.18 1.62-1.74s-.28-.36-.74-.39-1.21 0-1.82 0-1.23-.19-1.85-.24c-.26 0-.88-.15-.92.31-.07.84 2.19.12 2 2.38a7.4 7.4 0 0 1-.91 2.78l-3.53 6.99c-.08.16-.19.49-.32.48s-.21-.36-.27-.53l-2.2-8a11 11 0 0 1-.56-3.38c.08-1 1.35-.55 1.4-1.19 0-.41-.08-.4-.77-.45-.35 0-1 0-2.36-.09-.74-.06-1.47-.21-2.18-.27-.33 0-1-.27-1 .31 0 .16.26.33.32.36a1.92 1.92 0 0 1 1.45 1.57l4.28 14.41c.31 1 .51 1.29.72 1.31s.36-.12.65-.72l7-14Z"
        className="Andorra_svg__cls-23"
      />
      <path
        id="Andorra_svg__path2762"
        d="M615.28 500.59c0 2.46-2.11 2-2.11 3 0 .41.43.3.67.3.58 0 1.17-.09 1.86-.08s1.5.11 2.56.12c.29 0 .83 0 .83-.31 0-1.13-2.78.48-2.74-4.15l.07-8.19c0-.22.05-.39.18-.39s.23.13.39.32l10.32 12.63a.64.64 0 0 0 .56.34c.26 0 .26-.19.27-.72l.12-13.52c0-2.54 1.86-1.94 1.86-2.66 0-.08 0-.32-.41-.32-.19 0-1 .09-2.32.07s-2.12-.11-2.47-.11-.35.23-.35.4c0 .8 2.64.39 2.62 2.58l-.07 8c0 .6 0 .89-.18.89s-.38-.29-.66-.63l-8.63-10.71c-.39-.46-.13-.63-.82-.63-1.15 0-1.72.08-2.28.07-.41 0-.8-.1-1.22-.1a.36.36 0 0 0-.37.4c0 1.16 2.44-.39 2.4 4.24l-.09 9.16Z"
        className="Andorra_svg__cls-23"
      />
      <path
        id="Andorra_svg__path2764"
        d="M636.29 489.74c0-2.29 1.64-1.41 1.64-2.23 0-.29-.1-.34-.75-.34-1.24 0-2 .08-2.8.07s-1.61-.11-2.45-.12c-.2 0-.74-.08-.74.34 0 .84 2.33.18 2.31 2.38v11.57c0 2.29-1.58 1.65-1.59 2.49 0 .12 0 .29.24.29.56 0 1.5-.08 2.43-.07 1.69 0 2.49.12 3.3.12.5 0 .69-.09.7-.35 0-.77-2.44.31-2.41-2.65l.1-11.5Z"
        className="Andorra_svg__cls-23"
      />
      <path
        id="Andorra_svg__path2766"
        d="M645.38 500.94c0 2.87-2.44 1.74-2.43 2.68 0 .53.38.5.77.5.86 0 1.58-.11 3-.13s2.17.08 3 .07c.63 0 1.06.06 1.06-.51s-2.78 0-2.8-2.92l-.1-10.9c0-1.15.21-1.28 1.1-1.28h1.84c2.49-.12 1.82 2.57 2.69 2.56.57 0 .32-.94.27-1.23l-.26-2.22c0-.24 0-.58-.35-.57-2 0-3.47.12-6.63.15s-4.63-.06-6.65 0c-.32 0-.32.34-.34.58l-.32 3.19c0 .31-.16.84.29.84 1 0 .3-3.16 2.75-3.18h1.83c.88 0 1.1.11 1.11 1.27l.1 11.18Z"
        className="Andorra_svg__cls-23"
      />
      <path
        id="Andorra_svg__path2768"
        d="M658 496.38c-.39 0-.69.08-.71-.16a2.3 2.3 0 0 1 .17-.91l1.33-4.39c.08-.27.17-.3.21-.3s0 0 .19.18l2.12 4.21a2.3 2.3 0 0 1 .3.87c0 .24-.28.24-.67.27Zm3.71 1c.56 0 .69.19 1.55 2a4.5 4.5 0 0 1 .52 1.58c.11 1.46-1.44 1.32-1.39 2 0 .34.31.26.69.23.63-.05 1.43-.2 2.38-.28 1.43-.11 2-.06 2.79-.12.59-.05.79 0 .75-.42-.06-.8-1.15.23-2-1.42l-7-14.25c-.33-.7-.38-.74-.58-.73s-.35.49-.47.89l-4.72 15c-.43 1.39-1.55 1.33-1.5 1.88 0 .31.36.24.67.21.62 0 1.24-.19 1.89-.24s1.35 0 2-.07c.46 0 1.14.08 1.1-.42s-2.36-.08-2.49-1.81a7.6 7.6 0 0 1 .3-1.94c.38-1.62.82-1.75 1.19-1.78Z"
        className="Andorra_svg__cls-23"
      />
      <path
        id="Andorra_svg__path2770"
        d="M678.5 487.4c-.22-1.65-.13-1.68 2.47-2 4.15-.55 2.84 2.47 3.85 2.33.5-.06.29-.84.22-1.14l-.39-2.36a.46.46 0 0 0-.49-.4c-1.9.25-3.37.55-4.9.74-3.29.44-4.85.55-5.73.66a.43.43 0 0 0-.42.47c.12 1 2.46-.13 2.74 2l1.47 11.19c.39 2.92-1.42 1.84-1.28 2.94 0 .14.17.25.45.21 1.18-.16 2.07-.37 2.74-.46.94-.12 1.75-.13 2.57-.24.54-.07 1 0 .94-.51-.09-.65-2.44.27-2.78-2.38l-.47-3.54c-.18-1.39-.31-1.66.68-1.79l1.59-.21c2.24-.3 2 2.32 2.66 2.23.52-.07.27-.92.21-1.22l-.71-4.24c-.11-.64-.34-.56-.49-.54-.43.05-.2 2.26-2 2.51l-1.36.17c-.92.12-.94 0-1.08-1.07Z"
        className="Andorra_svg__cls-23"
      />
      <path
        id="Andorra_svg__path2772"
        d="M686.43 492.88c.89 4.81 4.36 7.48 8.65 6.68 6.81-1.26 7-7.31 6.42-10.63-.94-5-4.68-7.49-8.83-6.67-5.09.99-7.2 5.43-6.24 10.62m2.37-1.88c-.64-3.44-.18-6.9 3.42-7.64 2.74-.56 5.85 1.71 6.82 6.94.73 3.94.13 7.34-3.53 8.09s-6.07-3.89-6.71-7.39"
        className="Andorra_svg__cls-23"
      />
      <path
        id="Andorra_svg__path2774"
        d="M705.63 482.64c-.34-1.4.31-1.56 1.09-1.75 2.13-.51 3.73.94 4.28 3.24.33 1.38.52 2.73-2.68 3.5-.63.15-1.42.33-1.56-.25zm0 11.48c.71 2.95-1.19 2.59-1 3.34.12.47.54.29.77.24 1.06-.26 2.09-.6 3.23-.88.89-.21 1.48-.25 1.84-.34s.62-.3.57-.51c-.21-.84-2.06.62-2.67-1.89l-1-4.05c-.2-.82-.36-1 .76-1.23a1.74 1.74 0 0 1 2.21.79l2.66 3.28c1 1.2 2 2.51 3.68 2.11.84-.2 2.11-1.05 1.94-1.78a.33.33 0 0 0-.4-.25c-.21.05-.38.24-.6.29a.78.78 0 0 1-.84-.19c-2.23-2.59-4.84-5.56-4.88-5.7s.51-.59 1-1.28a3.81 3.81 0 0 0 .52-3.22c-.26-1.08-1.47-4.28-6.09-3.17-1.42.34-2.83.78-4.24 1.11s-1.52.27-2.49.5c-.26.06-.44.23-.38.47.2.84 2.29-.58 2.92 2.05l2.48 10.31Z"
        className="Andorra_svg__cls-23"
      />
      <path
        id="Andorra_svg__path2776"
        d="M723 490.23c.72 2.78-1.94 2.27-1.71 3.18.13.52.49.4.86.3.84-.21 1.52-.49 2.92-.85s2.13-.45 3-.67c.6-.16 1-.2.9-.76s-2.68.72-3.43-2.15l-2.72-10.55c-.29-1.12-.12-1.29.75-1.51l1.78-.46c2.39-.72 2.39 2 3.23 1.83.55-.14.08-1 0-1.26l-.79-2.09c-.08-.23-.17-.56-.48-.47-1.95.5-3.34 1-6.4 1.75s-4.5 1.06-6.46 1.57c-.31.08-.23.41-.19.65l.46 3.17c0 .31 0 .86.49.74.94-.24-.48-3.14 1.9-3.75l1.76-.46c.86-.22 1.1-.16 1.39 1Z"
        className="Andorra_svg__cls-23"
      />
      <path
        id="Andorra_svg__path2778"
        d="M734.15 475.42c-.61-2.21 1.19-1.81 1-2.6-.08-.27-.19-.29-.82-.12-1.19.33-1.92.63-2.67.84s-1.58.34-2.39.56c-.19.06-.73.13-.62.53.22.81 2.41-.5 3 1.62l3.09 11.15c.62 2.2-1.06 2-.83 2.83 0 .12.12.27.31.22.54-.15 1.41-.5 2.31-.75 1.63-.45 2.43-.57 3.21-.78.48-.14.64-.28.57-.54-.21-.74-2.25 1-3-1.88l-3.07-11.08Z"
        className="Andorra_svg__cls-23"
      />
      <path
        id="Andorra_svg__path2780"
        d="M738.78 480.82c1.55 4.64 5.36 6.8 9.5 5.41 6.56-2.19 5.94-8.22 4.87-11.42-1.62-4.84-5.67-6.77-9.67-5.38-4.9 1.69-6.38 6.38-4.7 11.39m2.09-2.15c-1.11-3.32-1.13-6.82 2.32-8.05 2.64-.93 6 .88 7.73 5.93 1.27 3.8 1.14 7.24-2.38 8.5s-6.54-3.05-7.67-6.38"
        className="Andorra_svg__cls-23"
      />
      <path
        id="Andorra_svg__path2782"
        d="M756.26 467.72c-.53-1.34.1-1.59.85-1.88 2-.8 3.82.41 4.68 2.61.53 1.32.9 2.62-2.17 3.83-.6.24-1.35.53-1.57 0l-1.79-4.53Zm1.61 11.37c1.11 2.82-.81 2.73-.53 3.44.18.45.57.22.8.13 1-.4 2-.88 3.07-1.31.85-.34 1.43-.46 1.77-.6s.57-.38.49-.58c-.31-.81-2 .9-2.89-1.5l-1.53-3.88c-.31-.79-.5-.89.57-1.32a1.76 1.76 0 0 1 2.31.47l3.09 2.87c1.14 1.06 2.34 2.22 3.94 1.59.8-.32 1.94-1.34 1.67-2a.33.33 0 0 0-.43-.2c-.2.08-.35.3-.55.37a.78.78 0 0 1-.87-.07c-2.57-2.25-5.56-4.83-5.62-5s.42-.66.8-1.4a3.81 3.81 0 0 0 .07-3.27c-.41-1-2.06-4-6.48-2.29-1.35.53-2.69 1.16-4 1.69s-1.47.48-2.4.84c-.24.1-.4.29-.31.51.32.81 2.19-.88 3.18 1.63l3.89 9.87Z"
        className="Andorra_svg__cls-23"
      />
      <path
        id="Andorra_svg__path2784"
        d="M796.33 416.52a48 48 0 0 1-9.71-13 38.3 38.3 0 0 1-3.45-9 33 33 0 0 1-1-6.74 51.7 51.7 0 0 1 1.24-12.56 42.2 42.2 0 0 1 8.24-18.28c1.29-1.6 2.78-3.61 4.2-4.51"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2786"
        d="M801.26 405.2a27 27 0 0 1-2.64-2.19 31.68 31.68 0 0 1-8.71-21.54c0-8.37 3.31-16.88 7.23-20.19"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2788"
        d="m789.36 379.35.26-3.23 1.07-5.14 1.52-4 1.72-3.3 2.21-2.66"
        className="Andorra_svg__cls-24"
      />
      <path
        id="Andorra_svg__path2790"
        d="M805.09 430.55c1 .39 2 .74 2.9 1a14.1 14.1 0 0 0 8 .18c5.71-1.71 9.38-7.05 6.4-14a11.46 11.46 0 0 0-3.51-4.31"
        className="Andorra_svg__cls-21"
      />
      <path
        id="Andorra_svg__path2792"
        d="M819.93 414.62a8.1 8.1 0 0 0-2.46-7.38 9.8 9.8 0 0 0-1.76-1.6"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2794"
        d="M816.67 406.59c-.09-3.76-3.17-6.45-7-7.12"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2796"
        d="M797.39 361.54c2 2.65 5.86 3.34 8.89 2.55a8.05 8.05 0 0 0 5-3.92 10 10 0 0 0-.93-10.86 14 14 0 0 0-2.75-2.88c-.22-.14-.44-.34-.67-.49"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2798"
        d="m811.86 354.17-.26 3.16-.9 2.16-1.41 2.06-1.6 1.21-2.46.9-2.16.15-1.61-.25"
        className="Andorra_svg__cls-24"
      />
      <path
        id="Andorra_svg__path2802"
        d="M807.33 423.28c.18.19.75.28 1 .4 2.86 1.71 8.5-.42 6.84-4.84"
        className="Andorra_svg__cls-8"
      />
      <path
        id="Andorra_svg__path2810"
        d="M793.07 199.32c5.12.4 9.87 5.92 9.81 11.32-.09 7.86-2.73 11.1-8.91 18.8-5.32 6.63-21.29 18.28-20.89 29.43a11 11 0 0 0 2.33 5.67"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2814"
        d="m772.57 256.93.7-3.42 1.51-3.16 2-3.17 3.36-4.32 2.66-3 4.32-4.37 3.72-3.77 2.36-2.71 3.11-3.77 2.77-4.17 1.66-3.41.9-4.42.27-5.48-.5-1.59"
        className="Andorra_svg__cls-24"
      />
      <path
        id="Andorra_svg__path2816"
        d="M786.65 268.48c1.56-5.33-.35-11-5.52-10.81"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2818"
        d="M769 271.53a14.2 14.2 0 0 0 4.14 2.79 10.11 10.11 0 0 0 8.6-.58"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2820"
        d="M781.87 190.33c6.48 0 12.14 7.22 12.14 14.62 0 8.54-4.54 13.76-7.87 17.71-2.67 3.18-5.57 6-9 9.5"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2822"
        d="M774.18 183.49a13.94 13.94 0 0 1 5.61 4.94c2.72 4 3.41 7.38 3.22 12.35-.32 8.53-6.46 14.44-12 18"
        className="Andorra_svg__cls-8"
      />
      <path
        id="Andorra_svg__path2826"
        d="M761.42 183.49a11.5 11.5 0 0 1 1.3 1.31c3.71 4.42 4 10.95 3.11 14.58-1.34 5.44-3.14 7.79-7.55 11"
        className="Andorra_svg__cls-8"
      />
      <path
        id="Andorra_svg__path2830"
        d="M748.05 181.25c5.32 4 6.91 11 5.14 18.13-1.26 5.11-4.47 8.17-8.48 10.61"
        className="Andorra_svg__cls-8"
      />
      <path
        id="Andorra_svg__path2834"
        d="M739 186.49a12.26 12.26 0 0 1 4.41 5.25c3.76 9.07-4.42 15.87-12 21a43 43 0 0 1-16.75 6.62"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2836"
        d="M730.39 204a8.46 8.46 0 0 1-6.36-3 6.6 6.6 0 0 1-1.43-2"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2838"
        d="M692.61 208.84a9.3 9.3 0 0 1-2.66-2c-1.79-2-3-4.71-1.61-8.85 1.28-3.83 7.43-14.57 7.73-22 .46-11.36-3.91-18.06-10.74-20.68"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2840"
        d="m695.5 173.5-.27 4.27-1.16 4.36-2.22 6-1.69 3.83-1.78 3.82-.89 2.67-.36 2 .27 1.87"
        className="Andorra_svg__cls-8"
      />
      <path
        id="Andorra_svg__path2842"
        d="M767.17 292.93c.64 1.87 1.69 2.52 3 3.91a27.3 27.3 0 0 0 12.45 7.16 15.66 15.66 0 0 0 12.75-1.77"
        className="Andorra_svg__cls-8"
      />
      <path
        id="Andorra_svg__path2862"
        d="M764.14 457.18a6.1 6.1 0 0 0 1.2 1.69c1.31 2.18 6.39 6 11 6.08 7.63.1 9.44-5.25 9.64-6.43 1-5.83-1-7.42-4-9.06a6.73 6.73 0 0 0-3.87-.56"
        className="Andorra_svg__cls-8"
      />
      <path
        id="Andorra_svg__path2864"
        d="m776.58 465 3.27-.65 2.46-1.31 1.35-1.36 1-1.55.65-2.51.05-1.76"
        className="Andorra_svg__cls-24"
      />
      <path
        id="Andorra_svg__path2866"
        d="M472.67 431.68a13.8 13.8 0 0 1-7.44 0c-5.72-1.71-10.35-7.18-8-14"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2868"
        d="m465.83 431.32 2.41.2 3.12-.25 3.11-1.11"
        className="Andorra_svg__cls-24"
      />
      <path
        id="Andorra_svg__path2870"
        d="M466.29 411.28c2.5 0 5 1.64 6.63 4.48a6.5 6.5 0 0 1 .81 3.11 5.52 5.52 0 0 1-2.06 4.46c-2.9 1.85-8.05 1.05-7.84-4.07"
        className="Andorra_svg__cls-8"
      />
      <path
        id="Andorra_svg__path2872"
        d="M463.88 418.82c0-2.5 1.59-4.52 3.56-4.52s3.57 2 3.57 4.52-1.6 4.52-3.57 4.52-3.56-2.02-3.56-4.52Z"
        className="Andorra_svg__cls-17"
      />
      <path
        id="Andorra_svg__path2874"
        d="M481.85 344.76c9.95 1.86 19.53 13.87 22.67 27 1.09 4.55 2.58 14.7.51 24.31a45.23 45.23 0 0 1-11.84 22.72 32 32 0 0 1-4.29 3.69l-2.12 1.44"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2876"
        d="M484.28 353.49a3.6 3.6 0 0 1 .84 2.16c.88 7.41-5.61 9.56-10.23 8.36a11.35 11.35 0 0 1-6.08-4.6 9.6 9.6 0 0 1-1.25-4.65"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2878"
        d="m484.57 356.38-.4 2.81-.66 1.25-.95 1.21-1.31 1-1.45.65-1.91.3-1.31.1"
        className="Andorra_svg__cls-24"
      />
      <path
        id="Andorra_svg__path2880"
        d="M477.44 350.12a4.5 4.5 0 0 0-1.71 1.17 4.7 4.7 0 0 0-1.06 1.68 8.3 8.3 0 0 0-.49 2.4"
        className="Andorra_svg__cls-5"
      />
      <path
        id="Andorra_svg__path2882"
        d="M470.78 399.38c4.08 0 7.66 3.92 7.66 8.11a7.67 7.67 0 0 1-2.08 5.28"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2884"
        d="M468 404.13c4.26 0 8.31 4.11 8.31 8.46a7.86 7.86 0 0 1-3 6.19"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2886"
        d="M483.71 409.37c.7-.85 1.12-1.31 1.79-2.18a23 23 0 0 0 1.39-1.9c.44-.7.64-1.12 1-1.85.56-1 .83-1.62 1.36-2.66"
        className="Andorra_svg__cls-5"
      />
      <path
        id="Andorra_svg__path2888"
        d="M486.73 428.92c-1.2.55-1.9.8-3.07 1.41-.88.47-1.36.77-2.21 1.3s-1.55 1-2.51 1.69-1.5 1.2-2.46 2"
        className="Andorra_svg__cls-5"
      />
      <path
        id="Andorra_svg__path2890"
        d="M506.69 358.79c-.65-.67-1-1.06-1.66-1.71s-1.06-1.08-1.81-1.71-1.17-.88-1.93-1.44"
        className="Andorra_svg__cls-5"
      />
      <path
        id="Andorra_svg__path2892"
        d="M507.05 361.31c3.91 5.25 6.49 9.77 7.69 15.59"
        className="Andorra_svg__cls-8"
      />
      <path
        id="Andorra_svg__path2894"
        d="M514.61 394a35.2 35.2 0 0 1-2.93 8.17 35.9 35.9 0 0 1-7.17 9.37"
        className="Andorra_svg__cls-8"
      />
      <path
        id="Andorra_svg__path2896"
        d="M514.74 351.69a16.53 16.53 0 0 1-7.27 9.42"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2898"
        d="M507.68 330.71c3.77 3 6 6 7.1 9.65"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2900"
        d="M512.09 307a9.6 9.6 0 0 1 2.49 3.56"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2902"
        d="M507.67 330.15a13.7 13.7 0 0 1-4.22 2.62"
        className="Andorra_svg__cls-8"
      />
      <path
        id="Andorra_svg__path2904"
        d="M507.48 331.94A25 25 0 0 1 505 333a10.1 10.1 0 0 1-3 .62"
        style={{
          fill: "none",
          strokeMiterlimit: 3.86,
          strokeWidth: ".99px",
          stroke: "#c6b37f",
        }}
      />
      <path
        id="Andorra_svg__path2906"
        d="M514.88 320.9c-1 3.43-3.24 6-6.8 9.29"
        className="Andorra_svg__cls-8"
      />
      <path
        id="Andorra_svg__path2908"
        d="M512.3 293.34a7.7 7.7 0 0 1 2.35 2.64"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2910"
        d="M514.89 302.83a16.8 16.8 0 0 1-3.14 4.8 24.92 24.92 0 0 1-17.75 8.09 20.62 20.62 0 0 1-12.17-3.53 19.25 19.25 0 0 1-8.24-11.26"
        className="Andorra_svg__cls-8"
      />
      <path
        id="Andorra_svg__path2912"
        d="M473.66 298.61a27 27 0 0 0 .84 3 15.7 15.7 0 0 0 1.87 3.44 16.7 16.7 0 0 0 2.57 3.18 16 16 0 0 0 2.81 2.24 33 33 0 0 0 3 1.61"
        className="Andorra_svg__cls-5"
      />
      <path
        id="Andorra_svg__path2914"
        d="M510 272.07a15.6 15.6 0 0 1 4.77 6.84"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2916"
        d="M514.83 288.12C513 294 507.71 301.34 497.42 304c-4.92 1.25-11.24-.31-13.4-2.15"
        className="Andorra_svg__cls-8"
      />
      <path
        id="Andorra_svg__path2918"
        d="M482.76 300.25a25 25 0 0 0 2.51 1.35 13.2 13.2 0 0 0 2.46.77 14.5 14.5 0 0 0 3.47.41 15.4 15.4 0 0 0 3.77-.3"
        className="Andorra_svg__cls-5"
      />
      <path
        id="Andorra_svg__path2920"
        d="M478.91 286.74c.53 5.32 4.1 9.31 10.85 9.44 9.5.18 15.27-13.66 6.83-23.38"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2922"
        d="m489.6 295.5 4.35-1.15 2.58-1.94 1.66-2.35 1.43-3.67.57-3"
        className="Andorra_svg__cls-8"
      />
      <path
        id="Andorra_svg__path2984"
        d="M480.79 280.18a25.5 25.5 0 0 0-4.94 1.72 18 18 0 0 0-7.12 5.91c-2.4 3.4-3.79 8.12-4.66 12.26a40 40 0 0 0 .33 13.44 31.6 31.6 0 0 0 4.65 11.38 18 18 0 0 0 2.09 2.7c2.61 2.61 5 4.22 9 3.41"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2986"
        d="M479.41 281.1c-3.84 2.38-6.7 2.94-9.68 6.4a56.8 56.8 0 0 0-5.3 13.76"
        className="Andorra_svg__cls-15"
      />
      <path
        id="Andorra_svg__path2930"
        d="M481.48 329.22a3.45 3.45 0 1 1 3.44 3.71 3.58 3.58 0 0 1-3.44-3.71"
        className="Andorra_svg__cls-6"
      />
      <path
        id="Andorra_svg__path2932"
        d="M457.55 333.13a32.6 32.6 0 0 0 4.69 4.7 33.85 33.85 0 0 0 12 6.66"
        className="Andorra_svg__cls-8"
      />
      <path
        id="Andorra_svg__path2934"
        d="M484.87 345.48c8.49-1 13.27-7.34 12.32-14.74-.72-5.64-5.89-10-9.41-10.23"
        className="Andorra_svg__cls-8"
      />
      <path
        id="Andorra_svg__path2936"
        d="m496.57 332.17-.7 4.37-.85 1.91-1.76 2.41-2.36 1.8-2.41 1.21-4.67 1.13"
        className="Andorra_svg__cls-24"
      />
      <path
        id="Andorra_svg__path2938"
        d="M514.84 266.8a13.2 13.2 0 0 1-7.4 8.09c-3.73 1.68-8 .11-10.35-1.67"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2940"
        d="m514.71 264.76-.91 2.61-1.1 1.91-1.51 2.11-2.11 1.91-2.51 1.21-2.11.5-1.31-.1"
        className="Andorra_svg__cls-24"
      />
      <path
        id="Andorra_svg__path2942"
        d="M498.71 257.58c3.68-.14 5.78 3.21 5.75 6"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2944"
        d="M505.16 261c-.7 2.6-2.1 5.81-6.17 5.46"
        className="Andorra_svg__cls-8"
      />
      <path
        id="Andorra_svg__path2948"
        d="M503.91 262.4v2"
        className="Andorra_svg__cls-24"
      />
      <path
        id="Andorra_svg__path2950"
        d="M497.85 207A23.2 23.2 0 0 0 508 218.8"
        className="Andorra_svg__cls-8"
      />
      <path
        id="Andorra_svg__path2952"
        d="M509.44 220.41c-1.61-.94-2.59-1.35-4.13-2.41a24.7 24.7 0 0 1-3.77-3.06 19.5 19.5 0 0 1-2.35-2.62c-.72-1-1-1.62-1.64-2.66"
        className="Andorra_svg__cls-5"
      />
      <path
        id="Andorra_svg__path2954"
        d="M512.69 200.47a30 30 0 0 0 1.29 3.47 15.9 15.9 0 0 0 2.88 4.12c1.82 2 3.37 2.57 5.53 4.21"
        className="Andorra_svg__cls-5"
      />
      <path
        id="Andorra_svg__path2956"
        d="M525.32 200.32a28 28 0 0 0 1.29 3.11 13.8 13.8 0 0 0 1.68 2.47 14.8 14.8 0 0 0 2.71 2.66 30 30 0 0 0 3.8 2.26"
        className="Andorra_svg__cls-5"
      />
      <path
        id="Andorra_svg__path2958"
        d="M543.32 196.71a3.21 3.21 0 1 1 3.54 3.39 3.48 3.48 0 0 1-3.54-3.39"
        className="Andorra_svg__cls-6"
      />
      <path
        id="Andorra_svg__path2960"
        d="M799.09 281.31c3.47 4.75 1.19 14.12-8.25 14.3a10.46 10.46 0 0 1-9-5.07"
        className="Andorra_svg__cls-8"
      />
      <path
        id="Andorra_svg__path2962"
        d="M490.3 278.61c-3.91-3.82-12.18-4.82-20.41.39a32 32 0 0 0-3.17 2.4 18 18 0 0 0-2.91 3.21 36.5 36.5 0 0 0-2.81 4.91 25.4 25.4 0 0 0-1.91 5.35 41.3 41.3 0 0 0-1.32 12.63c.23 1.95.42 3.75.74 5.4a37.5 37.5 0 0 0 4.49 12.48c1.81 3 6.33 9.93 15.58 10.85 3.63.36 9.83-1.31 10-6"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2964"
        d="M728.7 194.91c.62-3.34 4.64-4 6.15-2 2.32 3 .78 8.25-3.94 9.72a7.59 7.59 0 0 1-7.74-2.81c-2-2.52-1.8-5.65-1.08-8.13a9.15 9.15 0 0 1 3.49-4.33c5.49-4.17 14.37-3.21 17.28 3.82 3.76 9.07-4.42 15.87-12 21-9.49 6.45-20.3 7.62-28.44 7.53-18.48-.2-32.54-9-41.68-14.06-2.13-1.17-4.33-.93-5.43.4a4 4 0 0 0 .5 5.52"
        className="Andorra_svg__cls-8"
      />
      <path
        id="Andorra_svg__path2966"
        d="M732.41 191.79a3.41 3.41 0 0 1 3.09 1.64c2.32 3 .62 8.24-4.11 9.72"
        className="Andorra_svg__cls-8"
      />
      <path
        id="Andorra_svg__path2972"
        d="M629.36 200.56c3.11 2.37 5.3 5.3 4.93 10-.39 5.15-1.64 6.4-5.66 9.14"
        className="Andorra_svg__cls-26"
      />
      <path
        id="Andorra_svg__path2974"
        d="M764.9 219.24v31.89"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2976"
        d="M633.47 212.06a6.62 6.62 0 0 1-4.57 6.4"
        className="Andorra_svg__cls-26"
      />
      <path
        id="Andorra_svg__path2978"
        d="M667.2 183.92c-.11-3.42-3.48-3.78-4.77-3.78-3.73 0-4.74 2.33-9.39 4.82-5.83 3.13-8.34 3.83-13.52 3.88s-7.76-.75-13.59-3.88c-4.65-2.49-5.43-4.74-9.16-4.74a4.7 4.7 0 0 0-4.54 4.95 8.3 8.3 0 0 0 .12 1.74c.06.26.38.18.48.41a4.68 4.68 0 0 1 1-3.4 4.41 4.41 0 0 1 3.28-1.7c3.73 0 5.11 2.39 9.76 4.89 5.83 3.13 8.34 3.83 13.52 3.87s7.76-.74 13.59-3.87c4.65-2.5 6-5.09 9.71-5.09a2.74 2.74 0 0 1 2.63 2.16 6.6 6.6 0 0 1 .18 1.67c0 .15.23.14.27.31a5.3 5.3 0 0 0 .43-2.24Z"
        style={{
          stroke: "#713e2a",
          strokeMiterlimit: 3.86,
          fill: "#713e2a",
          strokeWidth: ".28px",
        }}
      />
      <path
        id="Andorra_svg__path2980"
        d="M557.49 196.91c0 3.47-2.56 5.66-6 6.39"
        className="Andorra_svg__cls-15"
      />
      <path
        id="Andorra_svg__path2988"
        d="M767.41 307.21c-7 7.67-.56 20.82 4.7 23.8 1.82 1.42 2.6.66 4.06 1.52"
        className="Andorra_svg__cls-8"
      />
      <path
        id="Andorra_svg__path2990"
        d="M767.78 292.56c-2.31 1.6-3.13 3.41-3.21 6.55a10.57 10.57 0 0 0 2.84 8.1c3.84 4 11.35 7.47 18.63 7.57a20.7 20.7 0 0 0 12.18-3.54 18.26 18.26 0 0 0 7.78-10.85"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path2992"
        d="M763.84 425.13a49 49 0 0 1-.27 5 38 38 0 0 1-4.22 14 37.6 37.6 0 0 1-8.44 11.45 39.6 39.6 0 0 1-11.75 8.24c-4.87 2.44-7.94 3.22-13.26 4.42a68 68 0 0 1-13.9 1.7 96 96 0 0 1-12.81-.34c-5.33-.36-8.29-1.11-13.61-1.57a107 107 0 0 0-11.3-.74 58 58 0 0 0-11.61.84 44 44 0 0 0-10.4 2.87c-5.43 2.2-11.56 6-12.86 7.73-1.31-1.7-7.44-5.53-12.86-7.73a44 44 0 0 0-10.45-2.91 58.6 58.6 0 0 0-11.61-.84 107 107 0 0 0-11.29.74c-5.33.46-8.29 1.21-13.62 1.57a96 96 0 0 1-12.8.34 68 68 0 0 1-13.87-1.71c-5.31-1.2-8.38-2-13.26-4.42a39.7 39.7 0 0 1-11.75-8.24 42.36 42.36 0 0 1-12.66-25.42 49 49 0 0 1-.27-5V219.66h248.79v205.47Z"
        className="Andorra_svg__cls-9"
      />
      <path
        id="Andorra_svg__path4023"
        d="M659.87 232.66h15.83v105h-15.83Z"
        className="Andorra_svg__cls-16"
      />
      <path
        id="Andorra_svg__path2994"
        d="M527.5 232.16h106.18v106H527.5Z"
        style={{
          stroke: "#713e2a",
          strokeMiterlimit: 3.86,
          strokeWidth: ".8px",
          fill: "#d32d27",
        }}
      />
      <g id="Andorra_svg__use3302">
        <path
          id="Andorra_svg__path2998"
          d="M583.9 315.6a26.3 26.3 0 0 0 1.11 6.83c1.21 3.52 1.21 3.52 2.32 5.23a17 17 0 0 0 4.92 5 12.2 12.2 0 0 0 7.69 2.21c7.09-.63 10.38-8.32 12-14.57 1.71-6.63 6.56-10.24 9.65-7.83 1.8 1.4 1.91 3.76.4 6-1.61 2.42-5.3 3.62-5.3 3.62l3.79 4.82a11.87 11.87 0 0 0 9.74-9.55c.6-3.21-1-9.22-6.32-11-6.85-2.29-11.23 2.59-13.34 6.71-2.9 5.66-4.14 16.06-12.18 14.46-4.37-.88-6.43-7.24-6.43-10.15l-3.2-3.38-4.75 1.5-.13.1Z"
          className="Andorra_svg__cls-29"
        />
      </g>
      <path
        id="Andorra_svg__path2998-2"
        d="M577.29 315.6a26 26 0 0 1-1.1 6.83C575 326 575 326 573.87 327.66a17 17 0 0 1-4.93 5 12.2 12.2 0 0 1-7.68 2.21c-7.1-.63-10.39-8.32-12-14.57-1.7-6.63-6.55-10.24-9.64-7.83-1.81 1.4-1.91 3.76-.4 6 1.61 2.42 5.29 3.62 5.29 3.62l-3.78 4.91a11.86 11.86 0 0 1-9.73-9.6c-.6-3.21 1-9.22 6.32-11 6.84-2.29 11.22 2.59 13.33 6.71 2.9 5.66 4.15 16.06 12.18 14.46 4.38-.88 6.43-7.24 6.43-10.15l3.19-3.42 4.72 1.51.13.1Z"
        className="Andorra_svg__cls-29"
        data-name="path2998"
      />
      <path
        id="Andorra_svg__path3000"
        d="m590.1 270.54 13.9-15.05a6.08 6.08 0 0 0 2.09-4.39l-2.87.45-.64-1.48-.15-1.48 3.86-.82c.06-.62 0-1.09.11-1.78s.25-1 .41-1.61l-4.22.28c.21-.74.16-1.13.4-1.82a5 5 0 0 1 .65-1.42c.78-.12 1.5-.3 2.46-.39s1.48-.06 2.42-.11c2.31-4.3 11.88-8.24 18.68-1.17 4.92 5.11 3.86 14.49-2.52 17a8.16 8.16 0 0 1-8.87-1.43l2.55-5c3.52 2.1 6.43-.52 6.23-3.23a5.93 5.93 0 0 0-5.63-5.83c-2.91-.25-5 1.42-6.33 4-.8 1.59-.43 2.76-.7 4.52a31 31 0 0 1-.69 4.93 11.4 11.4 0 0 1-3.07 4.64l-14.25 15.42-55.48 60-4.17-3.85 55.83-60.39Z"
        className="Andorra_svg__cls-3"
      />
      <path
        id="Andorra_svg__path3002"
        d="M549.26 275.82s3.49 17.28 15.35 43.2c6-2.21 9.58-3.62 16-3.62s9.94 1.2 16 3.62c11.86-25.92 15.34-43.2 15.34-43.2l-31.31-40.28Z"
        className="Andorra_svg__cls-29"
      />
      <g id="Andorra_svg__use3300">
        <path
          id="Andorra_svg__path3006"
          d="m583.64 249.17 21.73 28s-2.89 13.59-11.72 34.05a61.4 61.4 0 0 0-10-1.71Z"
          className="Andorra_svg__cls-3"
        />
      </g>
      <path
        id="Andorra_svg__path3006-2"
        d="m577.53 249.17-21.74 28s2.9 13.59 11.73 34.05a61.5 61.5 0 0 1 10-1.71Z"
        className="Andorra_svg__cls-3"
        data-name="path3006"
      />
      <path
        id="Andorra_svg__path3012"
        d="M672.81 380.65a19 19 0 0 1-2.54-1.06c.42-.33.76-.35 1.12-.72.5-.53.48-1 .76-1.7s.24-1.24.87-1.74a1.68 1.68 0 0 1 1.45-.21 1.62 1.62 0 0 1 1.09 1c.18.72-.2 1.14-.31 1.88a5.1 5.1 0 0 0-.25 1.9 8.6 8.6 0 0 0 .46 1.17 20 20 0 0 1-2.65-.52"
        className="Andorra_svg__cls-30"
      />
      <path
        id="Andorra_svg__path3014"
        d="M671.53 381.88a.82.82 0 0 1 .8-.83.81.81 0 0 1 .82.8.81.81 0 1 1-1.62 0Z"
        className="Andorra_svg__cls-30"
      />
      <path
        id="Andorra_svg__path3016"
        d="m669.26 360.54-.18-.13c-.5-.4-.54-.84-.78-1.44a5 5 0 0 1-.4-1.49 9 9 0 0 1 0-1.35 10 10 0 0 0 0-1.22 2.8 2.8 0 0 0-.28-1.22c-.12-.23-.51-.43-.4-.54s.33 0 .54 0a2.06 2.06 0 0 1 1.22.54 2.38 2.38 0 0 1 .87 1.36c.21.7.32 1.16.53 1.89a3.2 3.2 0 0 0 .36.95 4.8 4.8 0 0 0 .68.81 10 10 0 0 1-1 1.08 5.7 5.7 0 0 1-1.1.74Z"
        className="Andorra_svg__cls-30"
      />
      <path
        id="Andorra_svg__path3018-2"
        d="m672.16 358.34-.77.37a10 10 0 0 1-1 1.05 16 16 0 0 1-1.61 1.09 2.9 2.9 0 0 0-.77.56c-.32.42-.1.81-.32 1.29a4.9 4.9 0 0 1-.85 1.22 15 15 0 0 1-1.37 1.29 6.2 6.2 0 0 1-1.47 1.29 2.3 2.3 0 0 1-.44.24c-.28.09-.45 0-.73.08-.5.18-.66.73-1 .93.15.28.14.48.29.77s.91 1.57 1.05 1.86.35.9.68 1a4.1 4.1 0 0 0 1.7.17 13.7 13.7 0 0 1 2.62.6c.8.33 1.12.74 1.9 1.09a7 7 0 0 0 1.66.57 4 4 0 0 0 1.29.12c.32 0 .49-.16.81-.2a.4.4 0 0 1 .16 0v.56h.08l2.66 1.17a2.5 2.5 0 0 0-.24.49 2.15 2.15 0 0 0-.08 1.09c.81 2.44 1.5 4 1.9 4.12.79.3 1 1.11 1.49 1.93-.16.17-.29.26-.44.41a11.2 11.2 0 0 0-2.14 2.34c-1 1.53-1.62 1.55-.41 3.59.71 1.2 1.06 1.42 2 3.11a10.4 10.4 0 0 1 1 2.54 10 10 0 0 1 .41 2.55l1.25.48.84-.84.81-1.54v-1.17a1 1 0 0 1-.32-1c.09-.47.67-.38.93-.81.37-.59-.43-.95-.85-1.41-.78-.86-1.85-1.08-2.1-2.38-.07-.35.1-.55.49-.93 1.1-1.09 1.46-1.26 2.54-2.34a1.9 1.9 0 0 0 1.25.16c.36-.07.69.16 1.82.48a2.8 2.8 0 0 0 1.57 0l.49-.12a5 5 0 0 1 .16.89c.07 1.37-.2 3.87.2 4.52a4 4 0 0 1 .36.73 2.2 2.2 0 0 1 .29.85c0 .9.06 1.47 0 2.42a20 20 0 0 1-.29 2.26 2.57 2.57 0 0 1-.56 1.37c-.37.47-.77.54-1.25.89l-.12 1.29 1.45.61 1.66.4.88-.36a1.45 1.45 0 0 1 .21-.81 1.16 1.16 0 0 1 .6-.68c.47-.19 1 .16 1.17-.13s.08-.43 0-1c-.06-.86-.23-1.28-.36-2.14a15.4 15.4 0 0 1-.2-3.56 12.6 12.6 0 0 1 .2-2c.22-1.14.63-1.69.89-2.82a28 28 0 0 0 .48-3.19 31.4 31.4 0 0 0 12.07-.49c.22-.05 1-.32 1-.32a11.3 11.3 0 0 0 3.52 2.1v1.25c0 .37-.06.62.16.93a.73.73 0 0 0 .48.36.85.85 0 0 0 .85-.2c.29-.26.24-.59.32-1a4.4 4.4 0 0 0 0-.89 6 6 0 0 0 1.13.08 7 7 0 0 0 1.13 0c0 .11 0 .48.05.61 0 .32-.1.56 0 .85a.83.83 0 0 0 .64.52.84.84 0 0 0 .69-.12c.38-.24.34-.64.4-1.09a9 9 0 0 0 0-1c.28-.08 1.07-.37 1.33-.48a6 6 0 0 1-.12 1.05 6.6 6.6 0 0 1-.32 1.21 9.5 9.5 0 0 1-1 1.77 15 15 0 0 1-1.33 2c-.27.35-.47.5-.73.85s-.44.73-.77 1.17a6 6 0 0 1-1.21 1.38c-.89.71-1.48.14-2.7 1.09l-.28 1.33 1.85.68 1.66.33.56-.33a1.28 1.28 0 0 1 .29-1 1.4 1.4 0 0 1 1-.53c.46-.07 1 0 1.33-.28s.45-1.18.8-1.9a16.5 16.5 0 0 1 3.88-5.05c.79-.77 1.47-1 2.14-1.85.32-.42.67-.61.69-1.13 0-.37-.19-.54-.28-.89a12 12 0 0 1-.25-1.3c2 1 1.26.84 1.62 1.82.29.8 0 1.34.08 2.18s.6 1.44.69 2.42a9.6 9.6 0 0 1-.41 3 9.4 9.4 0 0 1-.6 2.59 5 5 0 0 1-1.5 2c-.27.22-.47.32-.76.52l-.17 1.33 1.46.49 2.1.56.48-.44c.21-.85-.07-2.09.53-2.18s.89 0 1-.41c0-.16.07-.42.12-.8.28-2.44.54-4.71.8-5.82s.28-1.52.53-2.46a8.3 8.3 0 0 1 .52-2.18c1-2.71-.26-3.07-1.37-4.72a3.9 3.9 0 0 1-.89-1.94c-.12-1.06.22-1.93.16-3.56s0-2.79 0-3.71l.45-.24a5.29 5.29 0 0 0 3.07-3.19 4.4 4.4 0 0 0 .4-1.9c0-.43-.08-.84-.12-1.33a3.7 3.7 0 0 0-.4-1.21 3.9 3.9 0 0 0-.73-1.09 7 7 0 0 0-3.51-1.9c-1.92-.69-3.24-.56-5.33-.73a35.3 35.3 0 0 0-5.54-.08c-2.59.15-4 .67-6.62 1a54 54 0 0 1-6.34.52c-2.92.06-5.71-.59-7.47-.44-3.16.27-3.22 1-8 1.37-2.49.21-5 .25-5 .25l-2.78-.89a3.13 3.13 0 0 0 1.89-1.34c.36-.47.31-.87.73-1.37s.57-.8 1-1.25a2.9 2.9 0 0 0-1.21-.57 3.5 3.5 0 0 0-1.21 0 4.4 4.4 0 0 0-1.58.45 3.7 3.7 0 0 0-1.09.77 26 26 0 0 0-2.82-1.58 12 12 0 0 0-3.88-1.17Zm2.54 15.39h.09Z"
        className="Andorra_svg__cls-16"
        data-name="path3018"
      />
      <path
        id="Andorra_svg__path3020"
        d="m729.19 374.64-1 .31a8.7 8.7 0 0 1-3.36.64c-3.42.26-5.52-1.36-9-1.09-1.82.14-2.62 1.54-4.48 2a11.6 11.6 0 0 1-2.19.36l.66-1.33a17.5 17.5 0 0 1-2.73.34 10 10 0 0 1-2-.17l1.31-1.23a9.4 9.4 0 0 1-1.67-.43 5.3 5.3 0 0 1-1.37-.81c.86-.15 1.34-.25 2.18-.46 2-.5 2.64-1.48 5-1.71 1.49-.15 3.92-.06 9.88.92 3.92.65 5.66.35 7.15-.33a2.6 2.6 0 0 0 1.43-2.31 2.82 2.82 0 0 0-1.13-2.34 2.34 2.34 0 0 0-1.44-.47"
        className="Andorra_svg__cls-31"
      />
      <path
        id="Andorra_svg__path3022"
        d="M672.38 363.12a2.4 2.4 0 0 0-1.73.38c-.62.38-.7.9-1.15 1.47.58.13.91.47 1.48.33a1.7 1.7 0 0 0 1-.65 2 2 0 0 0 .55-1.5h-.13Z"
        className="Andorra_svg__cls-32"
      />
      <path
        id="Andorra_svg__path3024"
        d="M686.92 380.16s.34.62.52 1a9.7 9.7 0 0 1 .68 1.89 27 27 0 0 1 .31 2.71 5 5 0 0 0 .1.49l-.07 1.46"
        className="Andorra_svg__cls-31"
      />
      <path
        id="Andorra_svg__path3026"
        d="m697.24 378.76-.46 1.72c-.45 1.75-.87 2.69-1.21 4.47-.06.3-.11.57-.14.83"
        className="Andorra_svg__cls-31"
      />
      <path
        id="Andorra_svg__path3028"
        d="m673.92 374.29 2.88 1.33a12 12 0 0 0 4.52-5.07 17.9 17.9 0 0 0 1.76-5.57l-2.31-.75-.46.09c-.72 2.23-.9 3.5-2.09 5.42a14.9 14.9 0 0 1-3.43 3.92z"
        className="Andorra_svg__cls-30"
      />
      <path
        id="Andorra_svg__path3032"
        d="M680.29 397.7a15 15 0 0 1 1.19-1.63 17 17 0 0 1 1.69-1.49 1.7 1.7 0 0 1 .63.09 11.7 11.7 0 0 1-.68 3.56 4.6 4.6 0 0 1-.51 1.26 5 5 0 0 1-.61.67c-.66-1-1.72-1.67-1.71-2.46"
        className="Andorra_svg__cls-30"
      />
      <path
        id="Andorra_svg__path3034"
        d="M722.94 400.09a16 16 0 0 1 1.9.7 16 16 0 0 1 1.89 1.22 1.5 1.5 0 0 1 .09.62 12 12 0 0 1-2 .33 13 13 0 0 1-1.63 0 4.3 4.3 0 0 1-1.35-.14 6 6 0 0 1-.82-.4c.76-.9 1.16-2.12 1.92-2.33"
        className="Andorra_svg__cls-30"
      />
      <path
        id="Andorra_svg__path3036"
        d="M710.34 397.46a9.7 9.7 0 0 1 3.79 1.92 1.3 1.3 0 0 1 .08.62 10.7 10.7 0 0 1-2 .32 10 10 0 0 1-1.63 0 4.4 4.4 0 0 1-1.36-.13 5.6 5.6 0 0 1-.81-.41c.77-.9 1.17-2.11 1.93-2.32"
        className="Andorra_svg__cls-30"
      />
      <path
        id="Andorra_svg__path3038"
        d="M687.92 400.21a16 16 0 0 1 1.9.7 15 15 0 0 1 1.9 1.22 1.6 1.6 0 0 1 .08.62 12 12 0 0 1-2 .33 13 13 0 0 1-1.62 0 4.4 4.4 0 0 1-1.36-.14 5.5 5.5 0 0 1-.81-.4c.76-.9 1.15-2.12 1.91-2.33"
        className="Andorra_svg__cls-30"
      />
      <path
        id="Andorra_svg__path3040"
        d="M676.33 361.7c-.79-.35-1.35-1.34-.85-2.05.2-.29.53-.23.73-.51a1.62 1.62 0 0 0 .17-1.09 5.8 5.8 0 0 0-.27-1.22 6.2 6.2 0 0 1-.17-1.35 2.93 2.93 0 0 1 .44-2 2.5 2.5 0 0 1 1.07-.79c.19.18-.07.65 0 1.07a5 5 0 0 0 .37 1.49c.26.72.62 1 .91 1.76a4.45 4.45 0 0 1 .54 1.76 2.94 2.94 0 0 1-.27 1.49 2.82 2.82 0 0 1-1.82 1.63 1.5 1.5 0 0 1-.85-.19"
        className="Andorra_svg__cls-30"
      />
      <path
        id="Andorra_svg__path3046"
        d="M681.4 380.65c1 .23.7 4.35 2.31 5.29"
        className="Andorra_svg__cls-31"
      />
      <path
        id="Andorra_svg__path3048"
        d="m718 387.9.49-.32a10.5 10.5 0 0 0 3.47-2.32"
        className="Andorra_svg__cls-33"
      />
      <path
        id="Andorra_svg__path3050"
        d="M708 385.63h0c4.56-1.14 7.6-3.42 9.79-3.71"
        className="Andorra_svg__cls-31"
      />
      <path
        id="Andorra_svg__path3052"
        d="M712.66 379.92c.38 0 .75 0 1.07-.08 1.9-.28 2.2.88 3.52 1.62 2.4 1.34 2.71 3 5.55 4.34l.42.2 1.1.55"
        className="Andorra_svg__cls-31"
      />
      <path
        id="Andorra_svg__path3064"
        d="M663.21 368.19a2.15 2.15 0 0 0 .91.07c.43 0 .63-.3 1.06-.32a1.27 1.27 0 0 1 .88.16 1.1 1.1 0 0 1 .36.44.86.86 0 0 1 .16.61.74.74 0 0 1-.79.54.7.7 0 0 1-.7-.35.58.58 0 0 1-.05-.51 1.36 1.36 0 0 1-1 0 1.33 1.33 0 0 1-.83-.64Z"
        className="Andorra_svg__cls-32"
      />
      <g id="Andorra_svg__use4038">
        <path
          id="Andorra_svg__path3012-2"
          d="M672.81 427.93a19 19 0 0 1-2.54-1.07c.42-.32.76-.34 1.12-.71.5-.53.48-1 .76-1.71s.24-1.23.87-1.73a1.68 1.68 0 0 1 1.45-.21 1.6 1.6 0 0 1 1.09 1c.18.73-.2 1.15-.31 1.88a5.2 5.2 0 0 0-.26 1.89 9 9 0 0 0 .46 1.17 20 20 0 0 1-2.64-.51"
          className="Andorra_svg__cls-30"
          data-name="path3012"
        />
      </g>
      <g id="Andorra_svg__use4040">
        <path
          id="Andorra_svg__path3014-2"
          d="M671.53 429.16a.82.82 0 0 1 .8-.83.8.8 0 0 1 .82.8.81.81 0 1 1-1.62 0Z"
          className="Andorra_svg__cls-30"
          data-name="path3014"
        />
      </g>
      <g id="Andorra_svg__use4030">
        <path
          id="Andorra_svg__path3016-2"
          d="m669.26 407.82-.18-.13c-.5-.4-.54-.85-.78-1.44a5.1 5.1 0 0 1-.4-1.49 9 9 0 0 1 0-1.35 10 10 0 0 0 0-1.22 2.8 2.8 0 0 0-.28-1.22c-.12-.23-.51-.44-.4-.54s.33 0 .54 0a2.06 2.06 0 0 1 1.24.57 2.38 2.38 0 0 1 .87 1.35c.21.71.32 1.17.53 1.9a3.2 3.2 0 0 0 .36.95 4.8 4.8 0 0 0 .68.81 11 11 0 0 1-1 1.08 5.7 5.7 0 0 1-1.1.74Z"
          className="Andorra_svg__cls-30"
          data-name="path3016"
        />
      </g>
      <path
        id="Andorra_svg__path3074"
        d="m729.19 421.91-1 .32a8.7 8.7 0 0 1-3.36.64c-3.42.26-5.52-1.36-9-1.09-1.82.14-2.62 1.53-4.48 2a11.6 11.6 0 0 1-2.19.36l.66-1.33a19 19 0 0 1-2.73.34 10 10 0 0 1-2-.17l1.31-1.23a9.4 9.4 0 0 1-1.67-.43 5 5 0 0 1-1.37-.82c.86-.14 1.34-.24 2.18-.45 2-.5 2.64-1.48 5-1.72 1.49-.14 3.92-.05 9.88.93 3.92.65 5.66.35 7.15-.33a2.6 2.6 0 0 0 1.43-2.31 2.8 2.8 0 0 0-1.13-2.34 2.28 2.28 0 0 0-1.44-.47"
        className="Andorra_svg__cls-31"
      />
      <path
        id="Andorra_svg__path3076"
        d="M672.38 410.4a2.36 2.36 0 0 0-1.73.38c-.62.38-.7.9-1.15 1.47.58.13.91.47 1.48.33a1.73 1.73 0 0 0 1-.66 2 2 0 0 0 .55-1.49h-.13Z"
        className="Andorra_svg__cls-34"
      />
      <path
        id="Andorra_svg__path3078"
        d="M686.92 425.25s.34.62.52 1a10 10 0 0 1 .68 1.9 27 27 0 0 1 .31 2.71c0 .18.06.34.1.49l-.07 1.45"
        className="Andorra_svg__cls-31"
      />
      <path
        id="Andorra_svg__path3080"
        d="m697.24 426-.46 1.73c-.45 1.74-.87 2.69-1.21 4.47-.06.29-.11.57-.14.83"
        className="Andorra_svg__cls-31"
      />
      <g id="Andorra_svg__use4036">
        <path
          id="Andorra_svg__path3028-2"
          d="m673.92 421.56 2.88 1.34a12 12 0 0 0 4.52-5.07 18 18 0 0 0 1.76-5.57l-2.31-.75-.46.09c-.72 2.23-.9 3.5-2.09 5.42a14.9 14.9 0 0 1-3.43 3.92z"
          className="Andorra_svg__cls-30"
          data-name="path3028"
        />
      </g>
      <g id="Andorra_svg__use4042">
        <path
          id="Andorra_svg__path3032-2"
          d="M680.29 445a15 15 0 0 1 1.19-1.63 17 17 0 0 1 1.69-1.49 1.7 1.7 0 0 1 .63.09 11.9 11.9 0 0 1-.68 3.56 4.6 4.6 0 0 1-.51 1.26 5.5 5.5 0 0 1-.61.67c-.66-1-1.72-1.68-1.71-2.46"
          className="Andorra_svg__cls-30"
          data-name="path3032"
        />
      </g>
      <g id="Andorra_svg__use4048">
        <path
          id="Andorra_svg__path3034-2"
          d="M722.94 447.37a16 16 0 0 1 1.9.7 14.5 14.5 0 0 1 1.89 1.22 1.44 1.44 0 0 1 .09.62 11 11 0 0 1-2 .32 10 10 0 0 1-1.63 0 4.7 4.7 0 0 1-1.35-.13 5 5 0 0 1-.82-.41c.76-.9 1.16-2.11 1.92-2.32"
          className="Andorra_svg__cls-30"
          data-name="path3034"
        />
      </g>
      <g id="Andorra_svg__use4046">
        <path
          id="Andorra_svg__path3036-2"
          d="M710.34 444.74a18 18 0 0 1 1.9.69 19 19 0 0 1 1.89 1.22 1.34 1.34 0 0 1 .08.63 11.6 11.6 0 0 1-2 .32 10 10 0 0 1-1.63 0 4.8 4.8 0 0 1-1.36-.13 7 7 0 0 1-.81-.41c.77-.9 1.17-2.06 1.93-2.32"
          className="Andorra_svg__cls-30"
          data-name="path3036"
        />
      </g>
      <g id="Andorra_svg__use4044">
        <path
          id="Andorra_svg__path3038-2"
          d="M687.92 447.49a16 16 0 0 1 1.9.7 15 15 0 0 1 1.9 1.22 1.6 1.6 0 0 1 .08.62 11 11 0 0 1-2 .32 10 10 0 0 1-1.62 0 4.4 4.4 0 0 1-1.36-.13 4.7 4.7 0 0 1-.81-.41c.76-.9 1.15-2.11 1.91-2.32"
          className="Andorra_svg__cls-30"
          data-name="path3038"
        />
      </g>
      <g id="Andorra_svg__use4032">
        <path
          id="Andorra_svg__path3040-2"
          d="M676.33 409c-.79-.36-1.35-1.35-.85-2.06.2-.28.53-.22.73-.51a1.58 1.58 0 0 0 .17-1.08 5.8 5.8 0 0 0-.27-1.22 6.2 6.2 0 0 1-.17-1.35 2.92 2.92 0 0 1 .44-2 2.4 2.4 0 0 1 1.07-.79c.19.18-.07.65 0 1.06a4.8 4.8 0 0 0 .37 1.49c.26.73.62 1 .91 1.76a4.55 4.55 0 0 1 .54 1.77 2.94 2.94 0 0 1-.27 1.49 2.64 2.64 0 0 1-.79 1.08 2.4 2.4 0 0 1-1 .54 1.4 1.4 0 0 1-.88-.18"
          className="Andorra_svg__cls-30"
          data-name="path3040"
        />
      </g>
      <path
        id="Andorra_svg__path3098"
        d="M681.4 427.93c1 .23.7 4.34 2.31 5.29"
        className="Andorra_svg__cls-31"
      />
      <path
        id="Andorra_svg__path3100"
        d="m718 435.18.49-.33a10.3 10.3 0 0 0 3.47-2.31"
        className="Andorra_svg__cls-33"
      />
      <path
        id="Andorra_svg__path3102"
        d="M708 432.91h0c4.56-1.15 7.6-3.42 9.79-3.71"
        className="Andorra_svg__cls-31"
      />
      <path
        id="Andorra_svg__path3104"
        d="M712.66 427.2a9 9 0 0 0 1.07-.09c1.9-.27 2.2.89 3.52 1.63 2.4 1.34 2.71 3 5.55 4.33l.42.21 1.1.55"
        className="Andorra_svg__cls-31"
      />
      <path
        id="Andorra_svg__path3114"
        d="M663.21 415.47a2.3 2.3 0 0 0 .91.07c.43 0 .63-.31 1.06-.32a1.22 1.22 0 0 1 .88.16 1 1 0 0 1 .36.44.85.85 0 0 1 .16.6.75.75 0 0 1-.79.55.71.71 0 0 1-.7-.36.55.55 0 0 1-.05-.5 1.51 1.51 0 0 1-1.83-.64Z"
        className="Andorra_svg__cls-34"
      />
      <path
        id="Andorra_svg__path3116"
        d="M527.89 430.05a26.6 26.6 0 0 0 2.8 8.54c1.9 3 1.2 2.93 5.52 7.76a31.1 31.1 0 0 0 8 5.8 34.7 34.7 0 0 0 8.84 3.23 65.6 65.6 0 0 0 21.41 2.06 127 127 0 0 0 13.24-1.37 139 139 0 0 1 14.37-1.3 78 78 0 0 1 7.94 0 67 67 0 0 1 9.44 1.3 103 103 0 0 1 14.16 4.12V349.52h-106.2v75.64s.22 3.7.41 4.92Z"
        className="Andorra_svg__cls-7"
      />
      <path
        id="Andorra_svg__path3118"
        d="M540.22 448.7c1.69 1.09 3.42 1.79 5 2.61a41 41 0 0 0 6.82 2.78V350.15h-11.82v98.56Z"
        className="Andorra_svg__cls-35"
      />
      <path
        id="Andorra_svg__path3120"
        d="M599.21 454.26V350.15h-11.8V455.2s8.09-.7 11.8-.94Z"
        className="Andorra_svg__cls-35"
      />
      <path
        id="Andorra_svg__path3122"
        d="M622.78 350.15H611v103.68a78.5 78.5 0 0 1 11.79 2.06Z"
        className="Andorra_svg__cls-35"
      />
      <path
        id="Andorra_svg__path3124"
        d="M796 265.48c9.54-.2 37.28 7.28 37.48 39.89.19 32.2-19.88 37.47-27.92 39.61"
        style={{
          fill: "none",
          stroke: "#713e2a",
          strokeMiterlimit: 3.86,
          strokeWidth: 1,
        }}
      />
      <path
        id="Andorra_svg__path3126"
        d="M798.53 265.47c16.46-.72 33.45 11.41 34.2 41.65.58 23.63-16.17 34.35-24.22 36.49"
        style={{
          fill: "none",
          stroke: "#713e2a",
          strokeMiterlimit: 3.86,
          strokeWidth: "1.04px",
        }}
      />
      <g id="Andorra_svg__use4025">
        <path
          id="Andorra_svg__path4023-2"
          d="M690.21 232.66H706v105h-15.79Z"
          className="Andorra_svg__cls-16"
          data-name="path4023"
        />
      </g>
      <g id="Andorra_svg__use4027">
        <path
          id="Andorra_svg__path4023-3"
          d="M720.54 232.66h15.84v105h-15.84Z"
          className="Andorra_svg__cls-16"
          data-name="path4023"
        />
      </g>
      <path
        id="Andorra_svg__path3134"
        d="M575.64 350.15v106.49c-.11 0-7.88.17-11.85-.24V350.17h11.85Z"
        className="Andorra_svg__cls-35"
      />
    </g>
  </svg>
);
export default SvgAndorra;
